/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import MoserObject from './MoserObject';
import UsageType from './UsageType';
import InstanceType from './InstanceType';
import KeyConstraintType from './KeyConstraintType';
import KeyCompositionType from './KeyCompositionType';
import HighLevelDataType from './HighLevelDataType';
import EditModeType from './EditModeType';
import ItemScanner from './ItemScanner';
import RegularAggregateType from './RegularAggregateType';
import SqlOperatorType from './SqlOperatorType';
import Notification from './Notification';
import SplitColumnTreatment from './SplitColumnTreatment';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (runtime) // getModuleObject
//@import com/ibm/bi/platform/moser/common/generated/metadata/UsageType (static) // UsageType
//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (static) // InstanceType
//@import com/ibm/bi/platform/moser/common/generated/metadata/KeyConstraintType (static) // KeyConstraintType
//@import com/ibm/bi/platform/moser/common/generated/metadata/KeyCompositionType (static) // KeyCompositionType
//@import com/ibm/bi/platform/moser/common/generated/metadata/HighLevelDataType (static) // HighLevelDataType
//@import com/ibm/bi/platform/moser/common/generated/metadata/EditModeType (static) // EditModeType
//@import com/ibm/bi/platform/moser/common/utils/ItemScanner (static) // replaceIdForExpr, collectIdentifiers
//@import com/ibm/bi/platform/moser/common/generated/metadata/RegularAggregateType (static) // RegularAggregateType
//@import com/ibm/bi/platform/moser/common/generated/metadata/SqlOperatorType (static) // SqlOperatorType
//@import com/ibm/bi/platform/moser/common/notify/Notification (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitColumnTreatment (static) // SplitColumnTreatment

/**
 * util class for setting property vale.
 */
export default class PropertySetter extends BaseMoserObject{

	static MUI_PROPERTY_PREFIX = "_MUI_";

	static MUI_TYPE = "type";

	static MUI_ID = "id";

	static REGX_DOT = "\\.";

	static STR_DOT = ".";

	static MUI_PROPERTY_UPDATE_ID_NOT_EXIST = 0;

	static MUI_PROPERTY_UPDATE_ID_NOT_UPADTE = 1;

	static MUI_PROPERTY_UPDATE_ID_UPADTED = 2;

	static MUI_PROPERTY_DATA_CACHE_EXPIRY = "_MUI_" + "data_cache";

	static DEFAULT_GOVERNOR_TRANSLATE_DM_CONTENT_VALUE = true;

	static GOVERNOR_IDENTIFIER = "_governor";

	static GOVERNOR_TRANSLATE_DM_CONTENT = "translateDMContent";

	static GOVERNOR_TEXT_LITERAL_CONVERSION_LOCALE = "textLiteralConversionLocale";

	static SHORTCUT_GROUP_TYPE_ID = "dummyGroup4ShortcutAlias";



	/**
	 * used by setIdentifier. This function makes required changes after setIdentifier.
	 * @param {ObjectType} obj 			object whose identifier is changed.
	 * @param {String} oldValue 		old identifier.
	 * @param {String} value 			new identifier.
	 */
	static updateModuleReference(obj, oldValue, value) {
		if (oldValue == null || value == null || value == oldValue) {
			if (value == null) {
				obj.idForExpression = null;
			}
			return;
		}
		var objType = obj.getObjectType();
		if ("Calculation" == objType || "Filter" == objType) {
			var module = MoserObject.getModuleObject(obj);
			if (!module) {
				return;
			}
			if (PropertySetter.getParentQuerySubject(obj)) {
				var f = obj;
				var oldIdForExpr = f.basicGetIdForExpression();
				var newIdForExpr = null;
				if (oldIdForExpr != null && oldIdForExpr.length > oldValue.length) {
					newIdForExpr = oldIdForExpr.substring(0, oldIdForExpr.length - oldValue.length) + value;
					f.idForExpression = newIdForExpr;
				}
				PropertySetter._updateExpressions("QueryItem", module, obj, oldIdForExpr, newIdForExpr);
				PropertySetter._updateModuleTranslationReference(module, oldIdForExpr, newIdForExpr);
				return;
			}
			PropertySetter._updateMDTVReference(module.basicGetMetadataTreeView(), oldValue, value);
			obj.idForExpression = value;
			PropertySetter._updateExpressions("Calculation", module, obj, oldValue, value);
			if ("Calculation" == objType) {
				PropertySetter.updateItemTypeIdForExpression(module, (obj).basicGetItem(), obj.idForExpression);
			}
			PropertySetter._updateModuleTranslationReference(module, oldValue, value);
			return;
		}
		if ("QuerySubject" == objType) {
			var module = MoserObject.getModuleObject(obj);
			if (!module) {
				return;
			}
			PropertySetter._updateMDTVReference(module.basicGetMetadataTreeView(), oldValue, value);
			PropertySetter._updateRelationshipListReference(module.basicGetRelationship(), oldValue, value);
			PropertySetter.updateDrillgroupReference(module.basicGetDrillGroup(), oldValue, value, objType);
			var qs = obj;
			qs.idForExpression = value;
			PropertySetter.updateIdForExpressionQuerySubject(qs, value);
			PropertySetter._updateExpressions("QuerySubject", module, obj, oldValue, value);
			PropertySetter._updateQuerySubjectListReference(module.basicGetQuerySubject(), oldValue, value);
			PropertySetter._updateModuleTranslationReference(module, oldValue, value);
			return;
		}
		if ("QueryItem" == objType) {
			var qs = PropertySetter.getParentQuerySubject(obj);
			var module = MoserObject.getModuleObject(qs);
			if (!module || !qs) {
				return;
			}
			var qsId = qs.identifier;
			var qi = obj;
			var oldIdForExpr = qi.basicGetIdForExpression();
			var newIdForExpr = null;
			if (oldIdForExpr != null && oldIdForExpr.length > oldValue.length) {
				newIdForExpr = oldIdForExpr.substring(0, oldIdForExpr.length - oldValue.length) + value;
				qi.idForExpression = newIdForExpr;
			}
			if (!(PropertySetter.isExtensionOfParentShortcut(qs, qi))) {
				PropertySetter._updateItemNormalization(qs.getItemNormalization(), oldValue, value);
			}
			if (PropertySetter.isShortcutOrAlias(qs, false)) {
				PropertySetter.refreshShortcutItemNorm(qs, false);
			}
			PropertySetter.updateDrillgroupReference(module.drillGroup, oldIdForExpr, newIdForExpr, objType);
			PropertySetter._updateItemTypeListQueryItemReference(qs.basicGetItem(), oldValue, value);
			var relationships = module.relationship;
			if (relationships) {
				for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var r = __exp_enFor0[__i_enFor0];
					var links = r.link;
					if (!links || links.length==0) {
						continue;
					}
					var left = r.left;
					var right = r.right;
					if (qsId == left.ref) {
						for (var __i_enFor1 = 0, __exp_enFor1 = links, __len_enFor1 = __exp_enFor1.length;
								__i_enFor1 < __len_enFor1; ++__i_enFor1) {
							var l = __exp_enFor1[__i_enFor1];
							if (oldValue == l.leftRef) {
								l.leftRef = value;
							}
						}
					} else if (qsId == right.ref) {
						for (var __i_enFor2 = 0, __exp_enFor2 = links, __len_enFor2 = __exp_enFor2.length;
								__i_enFor2 < __len_enFor2; ++__i_enFor2) {
							var l = __exp_enFor2[__i_enFor2];
							if (oldValue == l.rightRef) {
								l.rightRef = value;
							}
						}
					}
				}
			}
			if (newIdForExpr != null && module.querySubject) {
				for (var __i_enFor3 = 0, __exp_enFor3 = module.querySubject, __len_enFor3 = __exp_enFor3.length;
						__i_enFor3 < __len_enFor3; ++__i_enFor3) {
					var aQS = __exp_enFor3[__i_enFor3];
					PropertySetter._updateItemTypeListReference(aQS.basicGetItem(), oldIdForExpr, newIdForExpr, qs);
				}
			}
			PropertySetter._updateExpressions("QueryItem", module, obj, oldIdForExpr, newIdForExpr);
			PropertySetter.updateItemTypeIdForExpression(module, qi.basicGetItem(), qi.idForExpression);
			PropertySetter._updateModuleTranslationReference(module, oldIdForExpr, newIdForExpr);
			PropertySetter._updateTimeReference(obj, qs, oldIdForExpr, newIdForExpr);
			PropertySetter._updateTimeReference(obj, qs, oldValue, value);
			return;
		}
	}

	/**
	 * Adds extended query items to item normalization of a shortcut.
	 * @param {QuerySubject} qs 		     shortcut qs
	 * @param {Set} targetQIIds     set of identifiers of all target query items. this set will be modified.
	 * @param {Array} extendedQIList  list of extended query items
	 * @param {ObjectFactory} objectFactory   object factory object
	 * @param {boolean} bUndoable       the actions will be undoable or not
	 */
	static addShortcutQIToItemNormalization(qs, targetQIIds, extendedQIList, objectFactory, bUndoable) {
		if (!objectFactory) {
			return;
		}
		var itemNormalization = qs.getItemNormalization();
		if (!itemNormalization || !itemNormalization.basicGetItemNormalizationGroup() || itemNormalization.basicGetItemNormalizationGroup().length==0) {
			return;
		}
		var qiToAddList = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = extendedQIList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qi = __exp_enFor0[__i_enFor0];
			qiToAddList.push(qi);
		}
		var qiAllIds = targetQIIds;
		var unaddedQIList = PropertySetter._addQueryItemsToItemNormalization(qs, qiToAddList, qiAllIds, objectFactory, true, bUndoable);
		for (var __i_enFor1 = 0, __exp_enFor1 = unaddedQIList, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var qi = __exp_enFor1[__i_enFor1];
			PropertySetter.addQueryItemToItemNormalization(qs, qi, objectFactory);
		}
	}

	/**
	 * Resolves the item normalization from adding a query item to a query subject for regular tables and shortcuts. For regular tables, resolve query items not added to item normalizaiton. For shortcuts, resolve extended query items in dummy group.
	 * @param {QuerySubject} qs 		     shortcut qs
	 * @param {ObjectFactory} objectFactory   object factory object
	 */
	static updateItemNormFromAdd(qs, objectFactory) {
		var itemNormalization = qs.getItemNormalization();
		if (!itemNormalization || !itemNormalization.basicGetItemNormalizationGroup() || itemNormalization.basicGetItemNormalizationGroup().length==0) {
			return;
		}
		if (PropertySetter.isShortcutOrAlias(qs, false)) {
			var bUndoable = true;
			PropertySetter.refreshShortcutItemNorm(qs, bUndoable);
		} else {
			PropertySetter._addRemainingQIsToItemNorm(qs, itemNormalization, objectFactory);
		}
	}

	static getParentQuerySubject(moserObj) {
		if (!moserObj) {
			return null;
		}
		var parent = moserObj.getParent();
		if (!parent) {
			return null;
		}
		var objType = parent.getObjectType();
		if ("QuerySubject" == objType) {
			return parent;
		}
		if ("Module" == objType) {
			return null;
		}
		return PropertySetter.getParentQuerySubject(parent);
	}

	static getGovernor(module) {
		var parameterMapList = module.basicGetParameterMap();
		if (!parameterMapList) {
			return null;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = parameterMapList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var parameterMap = __exp_enFor0[__i_enFor0];
			if ("_governor" == parameterMap.getIdentifier()) {
				return parameterMap;
			}
		}
		return null;
	}

	static getParameterMapEntry(parameterMap, key) {
		var entryList = parameterMap.basicGetParameterMapEntry();
		if (!entryList || key == null) {
			return null;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = entryList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var entry = __exp_enFor0[__i_enFor0];
			if (key == entry.getKey()) {
				return entry;
			}
		}
		return null;
	}

	/**
	 * Refreshes the item normalization of a shortcut by re-adding extended items to the target item normalization.
	 * @param {QuerySubject} shortcut
	 * @param {boolean} bUndoable  adds to undo/redo stack if true
	 */
	static refreshShortcutItemNorm(shortcut, bUndoable) {
		if (!shortcut || !shortcut.getItemNormalization()) {
			return;
		}
		var module = MoserObject.getModuleObject(shortcut);
		if (!module) {
			return;
		}
		var targetQIIds = {};
		var extendedQIList = [];
		var target = PropertySetter.getShortcutTargetInDataModule(shortcut);
		PropertySetter._populateExtQIList(shortcut, targetQIIds, extendedQIList);
		if (target) {
			PropertySetter._setShortcutItemNormFromTarget(shortcut, target, bUndoable);
		} else {
			var itemNorm = shortcut.getItemNormalization();
			var groups = itemNorm.getItemNormalizationGroup();
			for (var i = groups.length - 1; i >= 0; --i) {
				var group = groups[i];
				var attrs = group.getAttribute();
				for (var j = attrs.length - 1; j >= 0; --j) {
					var attr = attrs[j];
					if (!(targetQIIds.hasOwnProperty(attr.getItemRef()))) {
						if (bUndoable) {
							group.removeAttributeAt(j);
						} else {
							attrs.splice(j, 1);
						}
					}
				}
				if (PropertySetter.isEmptyDummyItemNormGroup(group)) {
					if (bUndoable) {
						itemNorm.removeItemNormalizationGroupAt(i);
					} else {
						groups.splice(i, 1);
					}
				}
			}
		}
		PropertySetter.addShortcutQIToItemNormalization(shortcut, targetQIIds, extendedQIList, module.getObjectFactory(), bUndoable);
	}

	/**
	 * update ref in all DrillGroup.Segment.
	 * @param {Array} drills 		DrillGroup.
	 * @param {String} oldValue 		old id.
	 * @param {String} value 			new id.
	 * @param {String} objType 		type of the Object.
	 */
	static updateDrillgroupReference(drills, oldValue, value, objType) {
		if (value == null || !drills) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = drills, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var dg = __exp_enFor0[__i_enFor0];
			if (!dg.segment) {
				continue;
			}
			for (var __i_enFor1 = 0, __exp_enFor1 = dg.segment, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var sg = __exp_enFor1[__i_enFor1];
				PropertySetter._updateSegmentRefIfMatch(sg, oldValue, value, objType);
			}
		}
	}

	/**
	 * update ref in DrillGroup.Segment if required.
	 * @param {Segment} sg 			Segment.
	 * @param {String} oldValue 		old id.
	 * @param {String} value 			new id.
	 * @param {String} objType 		type of the Object.
	 */
	static _updateSegmentRefIfMatch(sg, oldValue, value, objType) {
		if ("QuerySubject" == objType) {
			var parts = sg.ref.split(new RegExp("\\."));
			if (parts.length == 2 && oldValue == parts[0]) {
				sg.ref = value + "." + parts[1];
			}
			return;
		}
		if (oldValue == sg.ref) {
			sg.ref = value;
		}
	}

	static _updateItemNormalization(itemNorm, oldId, newId) {
		if (!itemNorm) {
			return;
		}
		var groups = itemNorm.basicGetItemNormalizationGroup();
		if (!groups) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = groups, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var grp = __exp_enFor0[__i_enFor0];
			if (grp.key && grp.key.itemRef != null && grp.key.itemRef == oldId) {
				grp.key.itemRef = newId;
			}
			if (!grp.attribute) {
				continue;
			}
			for (var __i_enFor1 = 0, __exp_enFor1 = grp.attribute, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var attr = __exp_enFor1[__i_enFor1];
				if (attr.itemRef != null && attr.itemRef == oldId) {
					attr.itemRef = newId;
				}
			}
		}
	}

	static _updateItemTypeListQueryItemReference(itemTypes, oldId, newId) {
		if (!itemTypes) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = itemTypes, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itemType = __exp_enFor0[__i_enFor0];
			PropertySetter._updateItemTypeQueryItemReference(itemType, oldId, newId);
		}
	}

	static _updateItemTypeQueryItemReference(itemType, oldId, newId) {
		var qi = itemType.getQueryItem();
		if (qi) {
			if (qi.facetDefinition && qi.facetDefinition.sortList && qi.facetDefinition.sortList.sortItem) {
				for (var __i_enFor0 = 0, __exp_enFor0 = qi.facetDefinition.sortList.sortItem, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var s = __exp_enFor0[__i_enFor0];
					if (oldId == s.ref) {
						s.ref = newId;
					}
				}
			}
			PropertySetter._updateItemTypeListQueryItemReference(qi.basicGetItem(), oldId, newId);
			return;
		}
		var folder = itemType.getFolder();
		if (folder) {
			PropertySetter._updateItemTypeListQueryItemReference(folder.basicGetItem(), oldId, newId);
			return;
		}
	}

	/**
	 * Adds list of query items to the item normalization of a query subject.
	 * @param {QuerySubject} qs 		         qs
	 * @param {Array} qiList              list of query items to add.
	 * @param {Set} idsInItemNorm       set of identifiers in the existing item normalization
	 * @param {ObjectFactory} objectFactory       object factory
	 * @param {boolean} isShortcutOrAlias   is the qs a shortcut or alias
	 * @param {boolean} bUndoable           the actions will be undoable or not
	 */
	static _addQueryItemsToItemNormalization(qs, qiList, idsInItemNorm, objectFactory, isShortcutOrAlias, bUndoable) {
		var changeFlag;
		var unaddedQIList;
		var qiToAddList = qiList;
		do {
			changeFlag = false;
			unaddedQIList = [];
			for (var __i_enFor0 = 0, __exp_enFor0 = qiToAddList, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var qi = __exp_enFor0[__i_enFor0];
				if (idsInItemNorm.hasOwnProperty(qi.getIdentifier())) {
					continue;
				}
				var idsInExprList = [];
				var idsInExprMap = {};
				var b = PropertySetter.getIdsInQueryItemExpression(qs.getIdentifier(), qi, idsInExprList, idsInExprMap);
				var containsAll = true;
				for (var __i_enFor1 = 0, __exp_enFor1 = idsInExprList, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var id = __exp_enFor1[__i_enFor1];
					if (!(idsInItemNorm.hasOwnProperty(id))) {
						containsAll = false;
					}
				}
				if (containsAll || !b && isShortcutOrAlias) {
					PropertySetter.addQueryItemToItemNormalizationGroup(qs.getIdentifier(), qs.getItemNormalization(), qi, objectFactory, bUndoable);
					idsInItemNorm[qi.getIdentifier()] = 1;
					changeFlag = true;
				} else {
					unaddedQIList.push(qi);
				}
			}
			qiToAddList = unaddedQIList;
		} while (changeFlag);
		return unaddedQIList;
	}

	/**
	 * Resolves the item normalization of query items for query subjects. Attempts to resolve other query items not in the item normalization.
	 * @param {QuerySubject} qs 		         qs
	 * @param {ItemNormalizationType} itemNormalization   item normalization of qs
	 * @param {ObjectFactory} objectFactory       object factory
	 */
	static _addRemainingQIsToItemNorm(qs, itemNormalization, objectFactory) {
		var idsInItemNorm = PropertySetter._collectItemNormQueryItemIds(itemNormalization, true);
		var qiToAddList = [];
		var queryItems = PropertySetter.getQueryItems(qs);
		for (var __i_enFor0 = 0, __exp_enFor0 = queryItems, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qi = __exp_enFor0[__i_enFor0];
			if (qi.getInstanceType()) {
				var parent = qi.getParent();
				if (parent) {
					parent = parent.getParent();
					if (parent && "QueryItem" == parent.getObjectType()) {
						var parentQI = parent;
						var splitDef = parentQI.basicGetSplitDefinition();
						if (splitDef && !(splitDef.length==0)) {
							continue;
						}
					}
				}
			}
			if (!(idsInItemNorm.hasOwnProperty(qi.getIdentifier()))) {
				qiToAddList.push(qi);
			}
		}
		PropertySetter._addQueryItemsToItemNormalization(qs, qiToAddList, idsInItemNorm, objectFactory, false, true);
	}

	/**
	 * update MDTV reference after Identifier of the Object is changed.
	 * @param {Array} mdtv 		- MDTV.
	 * @param {String} oldId 		- old Identifier.
	 * @param {String} newId 		- new Identifier.
	 */
	static _updateMDTVReference(mdtv, oldId, newId) {
		if (!mdtv) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = mdtv, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var folderType = __exp_enFor0[__i_enFor0];
			PropertySetter._updateFolderTypeReference(folderType, oldId, newId);
		}
	}

	/**
	 * update translation objects in module in translation objects.
	 * @param  translation          - list of translation objects.
	 * @param {String} oldIdForExpression   - old idForExpression.
	 * @param {String} newIdForExpression   - new idForExpression.
	 */
	static _updateModuleTranslationReference(module, oldIdForExpression, newIdForExpression) {
		if (!module) {
			return;
		}
		var translation = module.basicGetTranslation();
		if (!translation) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = translation, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			PropertySetter._updateTranslationReference(obj, oldIdForExpression, newIdForExpression);
		}
	}

	static _updateTimeReference(obj, parentQS, oldIdForExpressionOrIdentifier, newIdForExpressionOrIdentifier) {
		if ("QueryItem" == obj.getObjectType() && parentQS) {
			var timeRef = parentQS.basicGetTimeRef();
			if (!timeRef) {
				return;
			}
			var oldIdIndex = timeRef.indexOf(oldIdForExpressionOrIdentifier);
			if (oldIdIndex != -1) {
				timeRef.splice(oldIdIndex, 1);
				timeRef.splice(oldIdIndex, 0, newIdForExpressionOrIdentifier);
			}
		} else if ("QuerySubject" == obj.getObjectType() && !parentQS) {
			var qs = obj;
			var timeRef = qs.basicGetTimeRef();
			if (!timeRef) {
				return;
			}
			for (var i = timeRef.length - 1; i >= 0; --i) {
				var ref = timeRef[i];
				var parts = ref.split(new RegExp("\\."));
				var sb = "";
				if (parts.length > 1) {
					for (var j = 0; j < parts.length; ++j) {
						if (j == 0) {
							sb+=(newIdForExpressionOrIdentifier);
						} else {
							sb+=(".");
							sb+=(parts[j]);
						}
					}
				}
				var idForExpression = sb;
				if (!(idForExpression.length === 0)) {
					timeRef.splice(i, 1);
					timeRef.splice(i, 0, idForExpression);
				}
			}
		}
	}

	/**
	 * update fields in a translation object after Identifier of the Object is changed. Update the fields that reference other objects.
	 * @param {Translation} transObj 	          - Translation.
	 * @param {String} oldIdForExpression   - old idForExpression.
	 * @param {String} newIdForExpression   - new idForExpression.
	 */
	static _updateTranslationReference(transObj, oldIdForExpression, newIdForExpression) {
		if (!transObj || oldIdForExpression == null || newIdForExpression == null) {
			return;
		}
		var fromRef = transObj.getFromRef();
		if (oldIdForExpression == fromRef) {
			transObj.fromRef = newIdForExpression;
		}
		var toRef = transObj.getToRef();
		if (oldIdForExpression == toRef) {
			transObj.toRef = newIdForExpression;
		}
		var idRef = transObj.getIdRef();
		if (oldIdForExpression == idRef) {
			transObj.idRef = newIdForExpression;
		}
	}

	/**
	 * update FolderType reference after Identifier of the Object is changed.
	 * @param {FolderType} folderType 	- FolderType.
	 * @param {String} oldId 			- old Identifier.
	 * @param {String} newId 			- new Identifier.
	 */
	static _updateFolderTypeReference(folderType, oldId, newId) {
		var folderItemTypes = folderType.basicGetFolderItem();
		if (!folderItemTypes) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = folderItemTypes, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var folderItemType = __exp_enFor0[__i_enFor0];
			var ref = folderItemType.getRef();
			if (oldId == ref) {
				folderItemType.ref = newId;
			}
			var nestedFolder = folderItemType.getFolder();
			if (!nestedFolder) {
				continue;
			}
			PropertySetter._updateFolderTypeReference(nestedFolder, oldId, newId);
		}
	}

	/**
	 * update reference in Relationships after Identifier of the Object is changed.
	 * @param {Array} relationships 		- Relationships.
	 * @param {String} oldId 				- old Identifier.
	 * @param {String} newId 				- new Identifier.
	 */
	static _updateRelationshipListReference(relationships, oldId, newId) {
		if (!relationships) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var relationship = __exp_enFor0[__i_enFor0];
			PropertySetter._updateRelationshipReference(relationship, oldId, newId);
		}
	}

	/**
	 * update Relationship reference after Identifier of the Object is changed.
	 * @param {Relationship} relationship 		- Relationship.
	 * @param {String} oldId 				- old Identifier.
	 * @param {String} newId 				- new Identifier.
	 */
	static _updateRelationshipReference(relationship, oldId, newId) {
		PropertySetter._updateCardinalityTypeReference(relationship.getLeft(), oldId, newId);
		PropertySetter._updateCardinalityTypeReference(relationship.getRight(), oldId, newId);
	}

	/**
	 * update CardinalityType reference after Identifier of the Object is changed.
	 * @param {CardinalityType} cardinality 		- CardinalityType.
	 * @param {String} oldId 				- old Identifier.
	 * @param {String} newId 				- new Identifier.
	 */
	static _updateCardinalityTypeReference(cardinality, oldId, newId) {
		var ref = cardinality.getRef();
		if (oldId == ref) {
			cardinality.ref = newId;
		}
	}

	/**
	 * update reference in QuerySubjects after Identifier of the Object is changed.
	 * @param {Array} querySubjects 		- QuerySubjects.
	 * @param {String} oldId 				- old Identifier.
	 * @param {String} newId 				- new Identifier.
	 */
	static _updateQuerySubjectListReference(querySubjects, oldId, newId) {
		if (!querySubjects) {
			return;
		}
		var oldIdParts = oldId.split(new RegExp("\\."));
		var newIdParts = newId.split(new RegExp("\\."));
		for (var __i_enFor0 = 0, __exp_enFor0 = querySubjects, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var querySubject = __exp_enFor0[__i_enFor0];
			PropertySetter._updateQuerySubjectReference(querySubject, oldId, oldIdParts, newId, newIdParts);
		}
	}

	/**
	 * update reference in QuerySubject after Identifier of the Object is changed.
	 * @param {QuerySubject} querySubject 		- QuerySubject.
	 * @param {String} oldId 				- old Identifier.
	 * @param {String[]} oldIdParts
	 * @param {String} newId 				- new Identifier.
	 * @param {String[]} newIdParts
	 */
	static _updateQuerySubjectReference(querySubject, oldId, oldIdParts, newId, newIdParts) {
		var ref = querySubject.basicGetRef();
		PropertySetter._updateRefList(ref, oldId, newId);
		var orgRef = querySubject.basicGetOriginalRef();
		PropertySetter._updateRefList(orgRef, oldId, newId);
		var queryOp = querySubject.getQueryOperation();
		if (queryOp) {
			PropertySetter._updateRefList(queryOp.basicGetQueryRef(), oldId, newId);
		}
		var joinOp = querySubject.getJoinOperation();
		if (joinOp) {
			PropertySetter._updateRefList(joinOp.basicGetQueryRef(), oldId, newId);
			PropertySetter._updateRelationshipListReference(joinOp.basicGetRelationship(), oldId, newId);
		}
		PropertySetter._updateItemTypeListReference(querySubject.basicGetItem(), oldId, newId, null);
		var status = PropertySetter._updateMuiIdentifierProperties("QuerySubject", querySubject, oldIdParts, newIdParts, "QuerySubject");
		if (status == 2 && queryOp) {
			for (var __i_enFor0 = 0, __exp_enFor0 = PropertySetter.getItemsWithQueryItemFilter(querySubject.basicGetItem()), __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var item = __exp_enFor0[__i_enFor0];
				var qi = item.queryItem;
				if (qi && qi.expression == null) {
					PropertySetter._updateMuiIdentifierProperties("QuerySubject", qi, oldIdParts, newIdParts, "QueryItem");
				}
			}
		}
	}

	/**
	 * Returns a set of identifier of query items in the item normalization group.
	 * @param {ItemNormalizationType} itemNormalization  qs
	 * @param {boolean} includeDummyGroup  include identifiers of query items in the dummy group for shortcuts
	 */
	static _collectItemNormQueryItemIds(itemNormalization, includeDummyGroup) {
		var idInItemNorm = {};
		var groups = itemNormalization.basicGetItemNormalizationGroup();
		for (var __i_enFor0 = 0, __exp_enFor0 = groups, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var grp = __exp_enFor0[__i_enFor0];
			if (!includeDummyGroup && "dummyGroup4ShortcutAlias" == grp.getIdentifier()) {
				continue;
			}
			var key = grp.getKey();
			if (key) {
				idInItemNorm[key.getItemRef()] = 1;
			}
			var attributeList = grp.basicGetAttribute();
			if (!grp.basicGetAttribute()) {
				continue;
			}
			for (var __i_enFor1 = 0, __exp_enFor1 = attributeList, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var attribute = __exp_enFor1[__i_enFor1];
				idInItemNorm[attribute.getItemRef()] = 1;
			}
		}
		return idInItemNorm;
	}

	/**
	 * update ref list.
	 * @param {Array} ref 		- ref list.
	 * @param {String} oldId 		- old Identifier.
	 * @param {String} newId 		- new Identifier.
	 */
	static _updateRefList(ref, oldId, newId) {
		if (!ref) {
			return;
		}
		for (var i = 0; i < ref.length; ++i) {
			if (oldId == ref[i]) {
				ref[i] = newId;
			}
		}
	}

	/**
	 * update reference in ItemType List after Identifier of the Object is changed.
	 * @param {Array} itemTypes 		- ItemType list.
	 * @param {String} oldId 			- old Identifier.
	 * @param {String} newId 			- new Identifier.
	 */
	static _updateItemTypeListReference(itemTypes, oldId, newId, srcQS) {
		if (!itemTypes) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = itemTypes, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itemType = __exp_enFor0[__i_enFor0];
			PropertySetter._updateItemTypeReference(itemType, oldId, newId, srcQS);
		}
	}

	/**
	 * update reference in ItemTypet after Identifier of the Object is changed.
	 * @param {ItemType} itemType 		- ItemType.
	 * @param {String} oldId 			- old Identifier.
	 * @param {String} newId 			- new Identifier.
	 */
	static _updateItemTypeReference(itemType, oldId, newId, srcQS) {
		var qi = itemType.getQueryItem();
		if (qi) {
			var splits = qi.basicGetSplitDefinition();
			if (splits) {
				for (var __i_enFor0 = 0, __exp_enFor0 = splits, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var split = __exp_enFor0[__i_enFor0];
					var ref = split.getRef();
					if (ref == null || ref.length === 0) {
						continue;
					}
					if (!srcQS) {
						if (!(PropertySetter.isOnePartNameToQueryItem(split)) && oldId == ref) {
							split.ref = newId;
						}
					} else {
						PropertySetter._updateSplitRefToQueryItem(qi, split, oldId, newId, srcQS);
					}
				}
			}
			PropertySetter._updateItemTypeListReference(qi.basicGetItem(), oldId, newId, srcQS);
			return;
		}
		var folder = itemType.getFolder();
		if (folder) {
			PropertySetter._updateItemTypeListReference(folder.basicGetItem(), oldId, newId, srcQS);
			return;
		}
	}

	/**
	 * update spitRef to QueryItem.
	 * @param {QueryItem} qi
	 * @param {SplitType} split
	 * @param {String} oldId
	 * @param {String} newId
	 * @param {QuerySubject} srcQS
	 */
	static _updateSplitRefToQueryItem(qi, split, oldId, newId, srcQS) {
		var parts = split.ref.split(new RegExp("\\."));
		if (parts.length > 1) {
			if (oldId == split.ref) {
				split.ref = newId;
			}
			return;
		}
		if (PropertySetter.isOnePartNameToQueryItem(split) && srcQS === PropertySetter.getParentQuerySubject(qi)) {
			var oldParts = oldId.split(new RegExp("\\."));
			if (oldParts[oldParts.length - 1] == split.ref) {
				var newParts = newId.split(new RegExp("\\."));
				split.ref = newParts[newParts.length - 1];
			}
		}
	}

	/**
	 * @param {QuerySubject} qs
	 * @param {String} newID
	 */
	static updateIdForExpressionQuerySubject(qs, newID) {
		var module = MoserObject.getModuleObject(qs);
		PropertySetter.updateItemTypeIdForExpression(module, qs.basicGetItem(), newID);
		PropertySetter.updateIdForExpressionEmbeddedFilter(qs.basicGetFilter(), newID);
		PropertySetter._updateTimeReference(qs, null, null, newID);
	}

	/**
	 * @param {Array} embedFilters
	 * @param {String} qsID
	 */
	static updateIdForExpressionEmbeddedFilter(embedFilters, qsID) {
		if (!embedFilters) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = embedFilters, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var flt = __exp_enFor0[__i_enFor0];
			var newIdforExpr = qsID + "." + flt.identifier;
			flt.idForExpression = newIdforExpr;
		}
	}

	/**
	 * Removes idForExpression for object in a query subject
	 * @param {QuerySubject} qs
	 */
	static cleanIdForExpressionQuerySubject(qs) {
		PropertySetter.cleanIdForExpression(qs.basicGetItem());
		var embedFilters = qs.basicGetFilter();
		if (!embedFilters) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = embedFilters, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var flt = __exp_enFor0[__i_enFor0];
			flt.idForExpression = null;
		}
	}

	/**
	 * Removes idForExpression for any query item, filter and children items
	 * @param {Array} items
	 */
	static cleanIdForExpression(items) {
		if (!items) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			var qi = itm.getQueryItem();
			if (qi) {
				qi.idForExpression = null;
				PropertySetter.cleanIdForExpression(qi.basicGetItem());
			}
			var flt = itm.getFilter();
			if (flt) {
				flt.idForExpression = null;
			}
			var calc = itm.getCalculation();
			if (calc) {
				calc.idForExpression = null;
				PropertySetter.cleanIdForExpression(calc.basicGetItem());
			}
			var folder = itm.folder;
			if (folder) {
				folder.idForExpression = null;
				PropertySetter.cleanIdForExpression(folder.basicGetItem());
			}
		}
	}

	/**
	 * update IdforExpression.
	 * @param {Array} items  items
	 * @param {String} parentIdForExpr  parent IdforExpression.
	 */
	static updateIdForExpression(items, parentIdForExpr) {
		PropertySetter.updateItemTypeIdForExpression(null, items, parentIdForExpr);
	}

	/**
	 * update IdforExpression.
	 * @param {Module} module  parent module
	 * @param {Array} items  items
	 * @param {String} parentIdForExpr  parent IdforExpression.
	 */
	static updateItemTypeIdForExpression(module, items, parentIdForExpr) {
		if (!items) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			var qi = itm.getQueryItem();
			if (qi) {
				var oldIdForExpr = qi.getIdForExpression();
				var newIdforExpr = parentIdForExpr + "." + qi.identifier;
				qi.idForExpression = newIdforExpr;
				PropertySetter.updateIdForExpression(qi.basicGetItem(), newIdforExpr);
				PropertySetter._updateModuleTranslationReference(module, oldIdForExpr, newIdforExpr);
				continue;
			}
			var flt = itm.getFilter();
			if (flt) {
				var oldIdForExpr = flt.getIdForExpression();
				var newIdforExpr = parentIdForExpr + "." + flt.identifier;
				flt.idForExpression = newIdforExpr;
				PropertySetter._updateModuleTranslationReference(module, oldIdForExpr, newIdforExpr);
				continue;
			}
			var folder = itm.folder;
			if (folder) {
				PropertySetter.updateIdForExpression(folder.basicGetItem(), parentIdForExpr);
			}
		}
	}

	static resetReferencedObject(module, qiId, qiIdForExpression, qsId) {
		var relationships = module.relationship;
		if (relationships) {
			for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var r = __exp_enFor0[__i_enFor0];
				var links = r.link;
				if (!links || links.length==0) {
					continue;
				}
				var left = r.left;
				var right = r.right;
				if (qsId == left.ref) {
					for (var __i_enFor1 = 0, __exp_enFor1 = links, __len_enFor1 = __exp_enFor1.length;
							__i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var l = __exp_enFor1[__i_enFor1];
						if (qiId == l.leftRef) {
							l.setReferencedObjectLeft(null);
						}
					}
				} else if (qsId == right.ref) {
					for (var __i_enFor2 = 0, __exp_enFor2 = links, __len_enFor2 = __exp_enFor2.length;
							__i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var l = __exp_enFor2[__i_enFor2];
						if (qiId == l.rightRef) {
							l.setReferencedObjectRight(null);
						}
					}
				}
			}
		}
		var drills = module.drillGroup;
		if (qiIdForExpression != null && drills) {
			for (var __i_enFor3 = 0, __exp_enFor3 = drills, __len_enFor3 = __exp_enFor3.length;
					__i_enFor3 < __len_enFor3; ++__i_enFor3) {
				var dg = __exp_enFor3[__i_enFor3];
				var segs = dg.segment;
				if (!segs) {
					continue;
				}
				for (var __i_enFor4 = 0, __exp_enFor4 = segs, __len_enFor4 = __exp_enFor4.length;
						__i_enFor4 < __len_enFor4; ++__i_enFor4) {
					var sg = __exp_enFor4[__i_enFor4];
					if (qiIdForExpression == sg.ref) {
						sg.setReferencedObject(null);
					}
				}
			}
		}
	}

	static resolveIdForExpression(obj) {
		if (!obj) {
			return;
		}
		var module = MoserObject.getModuleObject(obj);
		if (!module || !(module.isOverrideMode())) {
			return;
		}
		var idForExpression = PropertySetter.getIdForExpression(obj);
		if (idForExpression != null) {
			obj.idForExpression = idForExpression;
		}
	}

	static getIdForExpression(obj) {
		if (!obj) {
			return null;
		}
		var objType = obj.getObjectType();
		if ("QuerySubject" == objType) {
			return (obj).identifier;
		}
		if ("Calculation" == objType) {
			return (obj).identifier;
		}
		if ("Translation" == objType) {
			return (obj).identifier;
		}
		if ("DrillGroup" == objType) {
			return (obj).identifier;
		}
		if ("QueryItem" == objType || "Filter" == objType) {
			var id = (obj).identifier;
			if (id == null || id.length === 0) {
				return null;
			}
			var parts = [];
			parts.push(id);
			var parent = obj.getParent();
			while (parent) {
				objType = parent.getObjectType();
				if ("Module" == objType) {
					break;
				}
				if ("QuerySubject" == objType) {
					id = (parent).identifier;
					if (id == null || id.length === 0) {
						return null;
					}
					parts.push(id);
					break;
				}
				if ("QueryItem" == objType) {
					id = (parent).identifier;
					if (id == null || id.length === 0) {
						return null;
					}
					parts.push(id);
				}
				parent = parent.getParent();
			}
			var sb = "";
			var s = parts.length - 1;
			for (var i = s; i >= 0; --i) {
				if (i != s) {
					sb+=(".");
				}
				sb+=(parts[i]);
			}
			return sb;
		}
		return null;
	}

	static isEmptyDummyItemNormGroup(group) {
		return "dummyGroup4ShortcutAlias" == group.getIdentifier() && group.getAttribute().length==0;
	}

	static isEmptyRef(v) {
		return v == null || v.length === 0 || "none" == v || "None" == v || "NONE" == v;
	}

	static getAllQueryItemsInItems(items) {
		var qItems = [];
		if (!items) {
			return qItems;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.queryItem) {
				qItems.push(item.queryItem);
			} else if (item.folder) {
				Array.prototype.push.apply(qItems, PropertySetter.getAllQueryItemsInItems(item.folder.item));
			}
		}
		return qItems;
	}

	static getAllQueryItemsInQuerySubject(qs) {
		return PropertySetter.getAllQueryItemsInItems(qs.item);
	}

	static _resetSplitToQueryItem(module, srcQI, bset) {
		var srcQS = PropertySetter.getParentQuerySubject(srcQI);
		for (var __i_enFor0 = 0, __exp_enFor0 = module.querySubject, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var aQS = __exp_enFor0[__i_enFor0];
			for (var __i_enFor1 = 0, __exp_enFor1 = PropertySetter.getAllQueryItemsInQuerySubject(aQS), __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var aQI = __exp_enFor1[__i_enFor1];
				if (srcQI === aQI || !(PropertySetter.checkSplitRefToQueryItem(aQS, aQI, srcQS, srcQI))) {
					continue;
				}
				if (aQI.item) {
					aQI.item.length = 0;
				}
				if (bset) {
					PropertySetter._addQueryItemsForSplit(srcQI, aQI);
				}
			}
		}
	}

	/**
	 * check if splitRef of aQI references srcQI
	 * @param {QuerySubject} aQS
	 * @param {QueryItem} aQI
	 * @param {QuerySubject} srcQS
	 * @param {QueryItem} srcQI
	 * @return {boolean}
	 */
	static checkSplitRefToQueryItem(aQS, aQI, srcQS, srcQI) {
		var sp = aQI.splitDefinition;
		if (!sp || sp.length==0 || sp[0].ref == null || sp[0].ref.length === 0) {
			return false;
		}
		var parts = sp[0].ref.split(new RegExp("\\."));
		if (parts.length > 1) {
			return sp[0].ref == srcQI.idForExpression;
		}
		return PropertySetter.isOnePartNameToQueryItem(sp[0]) && aQS === srcQS && sp[0].ref == srcQI.identifier;
	}

	/**
	 * same rule as MUI: If it is one part name and usage is NOT fact, split to QuerySubject
	 * @param {String[]} parts
	 * @param {UsageType} u
	 * @return {boolean}
	 */
	static checkSplitToQuerySubjectByUsage(parts, u) {
		if (parts.length > 1) {
			return false;
		}
		return !(UsageType.FACT === u);
	}

	/**
	 * generate dynamic filters after split reference is set.
	 * @param {MoserObject} obj 			SplitType.
	 * @param {String} oldValue 		old value.
	 * @param {String} newValue 		new value.
	 */
	static _updateSplitRef(obj, oldValue, newValue) {
		var bOldEmpty = PropertySetter.isEmptyRef(oldValue);
		var bNewEmpty = PropertySetter.isEmptyRef(newValue);
		if (bOldEmpty && bNewEmpty || !bOldEmpty && !bNewEmpty && newValue == oldValue) {
			return;
		}
		var splitDef = obj;
		if (!(InstanceType.REFERENCE === splitDef.instanceType)) {
			return;
		}
		var module = MoserObject.getModuleObject(splitDef);
		if (!module || !(module.isOverrideMode())) {
			return;
		}
		var parent = splitDef.getParent();
		if (!parent || !("QueryItem" == parent.getObjectType())) {
			return;
		}
		var targetQueryItem = parent;
		splitDef.folderLabel = null;
		PropertySetter._resetSpecialFlagForOnePartNameToQueryItem(splitDef);
		if (targetQueryItem.item) {
			targetQueryItem.item.length = 0;
		}
		if (bNewEmpty) {
			if (!bOldEmpty) {
				var oldParts = oldValue.split(new RegExp("\\."));
				if (PropertySetter.checkSplitToQuerySubjectByUsage(oldParts, targetQueryItem.usage)) {
					PropertySetter._resetSplitToQueryItem(module, targetQueryItem, false);
				}
			}
			return;
		}
		var parts = newValue.split(new RegExp("\\."));
		if (PropertySetter.checkSplitToQuerySubjectByUsage(parts, targetQueryItem.usage)) {
			splitDef.folderLabel = PropertySetter.splitToQuerySubject(targetQueryItem, splitDef, module, parts[0]);
			PropertySetter._resetSplitToQueryItem(module, targetQueryItem, true);
		} else {
			splitDef.folderLabel = PropertySetter.splitToComparableQueryItem(targetQueryItem, splitDef, module, parts[0], newValue);
			if (parts.length == 1) {
				PropertySetter._setSpecialFlagForOnePartNameToQueryItem(splitDef);
			}
		}
	}

	static _getQuerySubjectById(module, id) {
		if (!module.querySubject) {
			return null;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = module.querySubject, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			if (id == qs.identifier || id == qs.idForExpression) {
				return qs;
			}
		}
		return null;
	}

	static ensureIdForExpression(parentId, items, allQueryItems) {
		if (!items) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			if (itm.queryItem) {
				if (itm.queryItem.idForExpression == null) {
					itm.queryItem.idForExpression = parentId + "." + itm.queryItem.identifier;
				}
				allQueryItems[itm.queryItem.idForExpression] = itm.queryItem;
				if (itm.queryItem.item) {
					PropertySetter.ensureIdForExpression(itm.queryItem.idForExpression, itm.queryItem.item, allQueryItems);
				}
				continue;
			}
			if (itm.filter) {
				if (itm.filter.idForExpression == null) {
					itm.filter.idForExpression = parentId + "." + itm.filter.identifier;
				}
				continue;
			}
			if (itm.folder) {
				PropertySetter.ensureIdForExpression(parentId, itm.folder.item, allQueryItems);
				continue;
			}
		}
	}

	static _needCloneQueryItem(qi, qs, allQueryItems) {
		if (!qs.itemNormalization) {
			return false;
		}
		if (!qs.itemNormalization.itemNormalizationGroup) {
			return false;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = qs.itemNormalization.itemNormalizationGroup, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var g = __exp_enFor0[__i_enFor0];
			if (!g.key) {
				continue;
			}
			if (g.key.getKeyConstraint() != KeyConstraintType.UNIQUE || g.key.getKeyComposition() != KeyCompositionType.INDEPENDENT) {
				continue;
			}
			var idforexpr = qs.identifier + "." + g.key.itemRef;
			var foundQI = allQueryItems[idforexpr];
			if (!foundQI) {
				continue;
			}
			if (PropertySetter._compatibleDT(qi, foundQI)) {
				return true;
			}
		}
		return false;
	}

	static _compatibleDT(qi, foundQI) {
		if (!qi.highlevelDatatype || !foundQI.highlevelDatatype) {
			return false;
		}
		if (qi.highlevelDatatype == HighLevelDataType.STRING && foundQI.highlevelDatatype == HighLevelDataType.STRING) {
			return true;
		}
		if ((qi.highlevelDatatype == HighLevelDataType.INTEGER || qi.highlevelDatatype == HighLevelDataType.DECIMAL) && (foundQI.highlevelDatatype == HighLevelDataType.INTEGER || foundQI.highlevelDatatype == HighLevelDataType.DECIMAL)) {
			return true;
		}
		if ((qi.highlevelDatatype == HighLevelDataType.DATE || qi.highlevelDatatype == HighLevelDataType.DATETIME) && (foundQI.highlevelDatatype == HighLevelDataType.DATE || foundQI.highlevelDatatype == HighLevelDataType.DATETIME)) {
			return true;
		}
		return false;
	}

	static splitToQuerySubject(targetQueryItem, splitDef, module, qsId) {
		var sourceQuerySubject = PropertySetter._getQuerySubjectById(module, qsId);
		if (!sourceQuerySubject) {
			return null;
		}
		PropertySetter.createFiltersFromSplitDefinition(targetQueryItem, splitDef, module, sourceQuerySubject);
		return sourceQuerySubject.label;
	}

	/**
	 * @param {QueryItem} targetQueryItem
	 * @param {SplitType} splitDef
	 * @param {Module} module
	 * @param {QuerySubject} sourceQuerySubject
	 * @return {Array}
	 */
	static createFiltersFromSplitDefinition(targetQueryItem, splitDef, module, sourceQuerySubject) {
		if (!sourceQuerySubject.item || sourceQuerySubject.item.length==0) {
			return null;
		}
		var allQueryItems = {};
		PropertySetter.ensureIdForExpression(sourceQuerySubject.identifier, sourceQuerySubject.item, allQueryItems);
		var parentIdForExpr = targetQueryItem.getIdForExpression();
		var bNeedCloneQueryItem = PropertySetter._needCloneQueryItem(targetQueryItem, sourceQuerySubject, allQueryItems);
		for (var __i_enFor0 = 0, __exp_enFor0 = sourceQuerySubject.item, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			try {
				var newItm = itm.clone();
				var b = [false, false];
				PropertySetter._adjustExpressionOfQueryItemFilter(newItm, b, parentIdForExpr, bNeedCloneQueryItem);
				if (b[0] && !b[1]) {
					if (!targetQueryItem.item) {
						targetQueryItem.item = [];
					}
					targetQueryItem.item.push(newItm);
					newItm._parent = targetQueryItem;
				}
			} catch (e) {
				throw e;
			}

		}
		return targetQueryItem.item;
	}

	static _adjustExpressionOfQueryItemFilter(item, b, pId, bNeedCloneQueryItem) {
		if (item.namedSet || item.itemHierarchy || !bNeedCloneQueryItem && item.queryItem) {
			b[1] = true;
			return;
		}
		if (item.queryItem) {
			b[0] = true;
			item.queryItem.expression = item.queryItem.idForExpression;
			item.queryItem.idForExpression = pId + "." + item.queryItem.identifier;
			item.queryItem.instanceType = InstanceType.REFERENCE;
			item.queryItem.editMode = EditModeType.RO;
			if (item.queryItem.item) {
				for (var __i_enFor0 = 0, __exp_enFor0 = item.queryItem.item, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var t = __exp_enFor0[__i_enFor0];
					PropertySetter._adjustExpressionOfQueryItemFilter(t, b, item.queryItem.idForExpression, bNeedCloneQueryItem);
				}
			}
			return;
		}
		if (item.filter) {
			b[0] = true;
			item.filter.idForExpression = pId + "." + item.filter.identifier;
			item.filter.instanceType = InstanceType.REFERENCE;
			item.filter.editMode = EditModeType.RO;
			return;
		}
		if (item.folder && item.folder.item) {
			for (var __i_enFor1 = 0, __exp_enFor1 = item.folder.item, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var t = __exp_enFor1[__i_enFor1];
				PropertySetter._adjustExpressionOfQueryItemFilter(t, b, pId, bNeedCloneQueryItem);
			}
		}
	}

	static splitToComparableQueryItem(targetQueryItem, splitDef, module, qsId, idforexprSrcQueryItem) {
		var idforexprTarget = targetQueryItem.getIdForExpression();
		if (idforexprSrcQueryItem == idforexprTarget) {
			return null;
		}
		var srcQuerySubject;
		if (qsId == idforexprSrcQueryItem) {
			srcQuerySubject = PropertySetter.getParentQuerySubject(targetQueryItem);
		} else {
			srcQuerySubject = PropertySetter._getQuerySubjectById(module, qsId);
		}
		if (!srcQuerySubject) {
			return null;
		}
		var allQueryItems = {};
		PropertySetter.ensureIdForExpression(srcQuerySubject.identifier, srcQuerySubject.item, allQueryItems);
		var srcQueryItem;
		if (qsId == idforexprSrcQueryItem) {
			for (var __i_enFor0 = 0, __exp_enFor0 = PropertySetter.getAllQueryItemsInQuerySubject(srcQuerySubject), __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var qi = __exp_enFor0[__i_enFor0];
				if (qi === targetQueryItem || !(qi.identifier == idforexprSrcQueryItem)) {
					continue;
				}
				srcQueryItem = qi;
				break;
			}
		} else {
			srcQueryItem = allQueryItems[idforexprSrcQueryItem];
		}
		if (!srcQueryItem) {
			return null;
		}
		PropertySetter.createItemsFromSplitDefinition(targetQueryItem, srcQueryItem, srcQuerySubject);
		return srcQueryItem.label;
	}

	static createItemsFromSplitDefinition(targetQueryItem, srcQueryItem, srcQuerySubject) {
		return PropertySetter._addQueryItemsForSplit(srcQueryItem, targetQueryItem);
	}

	static _addQueryItemsForSplit(srcQueryItem, targetQueryItem) {
		if (!srcQueryItem.item || srcQueryItem.item.length==0) {
			return null;
		}
		try {
			var targetQIClone = targetQueryItem.clone();
			targetQIClone.item = null;
			targetQIClone.splitDefinition = null;
			for (var __i_enFor0 = 0, __exp_enFor0 = srcQueryItem.item, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var itm = __exp_enFor0[__i_enFor0];
				var newItm = itm.clone();
				var b = [false, false];
				PropertySetter._adjustExpressionFromFilterToQueryItem(newItm, b, targetQIClone, srcQueryItem);
				if (b[0] && !b[1]) {
					if (!targetQueryItem.item) {
						targetQueryItem.item = [];
					}
					targetQueryItem.item.push(newItm);
					newItm._parent = targetQueryItem;
				}
			}
		} catch (e) {
			throw e;
		}

		return targetQueryItem.item;
	}

	static _adjustExpressionFromFilterToQueryItem(item, b, targetQI, srcQueryItem) {
		if (item.getNamedSet() || item.getItemHierarchy() || item.getQueryItem()) {
			b[1] = true;
			return;
		}
		if (item.filter) {
			b[0] = true;
			try {
				var newQI = targetQI.clone();
				newQI.identifier = item.filter.identifier;
				newQI.instanceType = InstanceType.REFERENCE;
				newQI.editMode = EditModeType.RO;
				if (item.filter.label != null) {
					newQI.label = item.filter.label + " [" + targetQI.label + "]";
				}
				newQI.expression = "case when " + item.filter.idForExpression + " then #$_this.parent.idForExpression# end";
				newQI.ref = null;
				newQI.idForExpression = targetQI.idForExpression + "." + newQI.identifier;
				item.queryItem = newQI;
				newQI._parent = item;
				item.filter = null;
			} catch (e) {
				throw e;
			}

			return;
		}
		if (item.folder && item.folder.item) {
			for (var __i_enFor0 = 0, __exp_enFor0 = item.folder.item, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var t = __exp_enFor0[__i_enFor0];
				PropertySetter._adjustExpressionFromFilterToQueryItem(t, b, targetQI, srcQueryItem);
			}
		}
	}

	/**
	 * @param {String} sourceCategory
	 * @param {Module} module
	 * @param {ObjectType} obj 				the item in query subject, query item or drag-able filter. Its identifier is changed.
	 * @param {String} oldIdforExpr
	 * @param {String} newIdforExpr
	 */
	static _updateExpressions(sourceCategory, module, obj, oldIdforExpr, newIdforExpr) {
		var muiPropObjType = obj.getObjectType();
		var candidates = [];
		var exprs = [];
		var types = [];
		var idforExprs = [];
		if ("Calculation" == sourceCategory) {
			PropertySetter.collectCandidatesForGlobaleCalculationFilter(module, obj, candidates, exprs, types, idforExprs);
		} else if ("QuerySubject" == sourceCategory) {
			muiPropObjType = "QueryItem";
			PropertySetter._collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, oldIdforExpr);
		} else if ("QueryItem" == sourceCategory) {
			PropertySetter._collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, null);
		} else {
			return;
		}
		PropertySetter.updateCandidatesExpression(sourceCategory, candidates, exprs, types, idforExprs, muiPropObjType, oldIdforExpr, newIdforExpr);
		if ("QueryItem" == obj.getObjectType()) {
			var oldIdforExprParts = oldIdforExpr.split(new RegExp("\\."));
			var newIdforExprParts = newIdforExpr.split(new RegExp("\\."));
			PropertySetter._updateMuiIdentifierProperties(sourceCategory, obj, oldIdforExprParts, newIdforExprParts, obj.getObjectType());
		}
	}

	/**
	 * @param {String} sourceCategory
	 * @param {Array} candidates
	 * @param {Array} exprs
	 * @param {Array} types
	 * @param {Array} idforExprs
	 * @param {String} muiPropObjType
	 * @param {String} oldIdforExpr
	 * @param {String} newIdforExpr
	 */
	static updateCandidatesExpression(sourceCategory, candidates, exprs, types, idforExprs, muiPropObjType, oldIdforExpr, newIdforExpr) {
		var oldIdforExprParts = oldIdforExpr.split(new RegExp("\\."));
		var newIdforExprParts = newIdforExpr.split(new RegExp("\\."));
		for (var i = 0; i < candidates.length; ++i) {
			var candidateObj = candidates[i];
			var candidateObjType = types[i];
			var status = PropertySetter._updateMuiIdentifierProperties(sourceCategory, candidateObj, oldIdforExprParts, newIdforExprParts, muiPropObjType);
			if (status >= 1) {
				if (status == 2) {
					PropertySetter._updateExpressionString(sourceCategory, candidateObj, candidateObjType, exprs[i], idforExprs[i], oldIdforExpr, newIdforExpr);
				}
				continue;
			}
			PropertySetter._updateExpressionString(sourceCategory, candidateObj, candidateObjType, exprs[i], idforExprs[i], oldIdforExpr, newIdforExpr);
		}
	}

	/**
	 * @param {String} sourceCategory
	 * @param {ObjectType} candidateObj 		object whose MUI Identifier properties might need to be changed.
	 * @param {String[]} oldIdforExprParts 	old IdForExpression, two parts.
	 * @param {String[]} newIdforExprParts 	new IdForExpression, two parts.
	 * @param {String} tp 			Object Type
	 * @return {int}
	 */
	static _updateMuiIdentifierProperties(sourceCategory, candidateObj, oldIdforExprParts, newIdforExprParts, tp) {
		var rt = 0;
		var props = candidateObj.basicGetProperty();
		if (!props) {
			return rt;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = props, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var p = __exp_enFor0[__i_enFor0];
			var nm = p.getName();
			if (nm == null || !(nm.startsWith("_MUI_"))) {
				continue;
			}
			var jMUIProp = PropertySetter._parseStringToJSONObjectNoThrow(p.getValue());
			if (!jMUIProp) {
				continue;
			}
			var b = PropertySetter._updateMuiIdentifierProperty(sourceCategory, jMUIProp, oldIdforExprParts, newIdforExprParts, tp);
			if (b == 2 && !(PropertySetter._updatePropertyValueNoThrow(p, jMUIProp))) {
				continue;
			}
			if (b > rt) {
				rt = b;
			}
		}
		return rt;
	}

	/**
	 * @param {String} s
	 * @return {Object}
	 */
	static _parseStringToJSONObjectNoThrow(s) {
		if (s == null || s.length === 0) {
			return null;
		}
		try {
			return JSON.parse(s);
		} catch (e) {
			throw e;
		}

	}

	/**
	 * @param {PropertyType} p
	 * @param {Object} jMUIProp
	 * @return {boolean}
	 */
	static _updatePropertyValueNoThrow(p, jMUIProp) {
		try {
			p.value = JSON.stringify(jMUIProp);
			return true;
		} catch (e) {
			throw e;
		}

	}

	/**
	 * @param {String[]} idParts
	 * @return {String}
	 */
	static _stringFromParts(idParts) {
		var sb = "";
		for (var i = 0; i < idParts.length; ++i) {
			if (i != 0) {
				sb+=(".");
			}
			sb+=(idParts[i]);
		}
		return sb;
	}

	/**
	 * @param {String} sourceCategory
	 * @param {Object} jMUIProp
	 * @param {String[]} oldIdforExprParts
	 * @param {String[]} newIdforExprParts
	 * @param {String} tp
	 * @return {int}
	 */
	static _updateMuiIdentifierProperty(sourceCategory, jMUIProp, oldIdforExprParts, newIdforExprParts, tp) {
		var rt = 0;
		var b;
		for (var __i_enFor0 = 0, __exp_enFor0 = Object.keys(jMUIProp), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var key = __exp_enFor0[__i_enFor0];
			var value = jMUIProp[key];
			if ((typeof value === "array" || value instanceof Array)) {
				for (var __i_enFor1 = 0, __exp_enFor1 = value, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var obj = __exp_enFor1[__i_enFor1];
					b = PropertySetter._updateJsonMuiIdentifierProperty(sourceCategory, obj, oldIdforExprParts, newIdforExprParts, tp);
					if (b > rt) {
						rt = b;
					}
				}
			} else {
				b = PropertySetter._updateJsonMuiIdentifierProperty(sourceCategory, value, oldIdforExprParts, newIdforExprParts, tp);
				if (b > rt) {
					rt = b;
				}
			}
		}
		return rt;
	}

	/**
	 * @param {String} sourceCategory
	 * @param {BaseMoserObject} obj
	 * @param {String[]} oldIdforExprParts
	 * @param {String[]} newIdforExprParts
	 * @param {String} tp
	 * @return {int}
	 */
	static _updateJsonMuiIdentifierProperty(sourceCategory, obj, oldIdforExprParts, newIdforExprParts, tp) {
		var rt = 0;
		if (obj instanceof Object) {
			var jObj = obj;
			var id = jObj["id"];
			var type = jObj["type"];
			if (id != null && !(id.length === 0) && type != null && !(type.length === 0)) {
				rt = 1;
				if (tp == type) {
					var idParts = id.split(new RegExp("\\."));
					if ("QueryItem" == sourceCategory) {
						if (idParts.length == 1) {
							if (oldIdforExprParts.length >= 2 && idParts[0] == oldIdforExprParts[1]) {
								jObj["id"] = newIdforExprParts[1];
								rt = 2;
							}
						} else if (idParts.length >= oldIdforExprParts.length && idParts[0] == oldIdforExprParts[0] && idParts[1] == oldIdforExprParts[1]) {
							idParts[1] = newIdforExprParts[1];
							jObj["id"] = PropertySetter._stringFromParts(idParts);
							rt = 2;
						}
					} else if ("QuerySubject" == sourceCategory || "Calculation" == sourceCategory) {
						if (idParts[0] == oldIdforExprParts[0]) {
							idParts[0] = newIdforExprParts[0];
							jObj["id"] = PropertySetter._stringFromParts(idParts);
							rt = 2;
						}
					}
				}
			}
		}
		return rt;
	}

	static _getJSONFunctionDef(o) {
		return PropertySetter._getJSONPropertyValue(o, "_MUI_expr");
	}

	static _getJSONPropertyValue(o, propName) {
		var props = o.basicGetProperty();
		if (!props) {
			return null;
		}
		var jFunc;
		for (var __i_enFor0 = 0, __exp_enFor0 = props, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var p = __exp_enFor0[__i_enFor0];
			if (propName == p.getName()) {
				var funcStr = p.getValue();
				if (funcStr != null) {
					try {
						jFunc = JSON.parse(funcStr);
					} catch (e) {
						throw e;
					}

				}
				break;
			}
		}
		return jFunc;
	}

	/**
	 * @param {String} srcObjType 		source object type.
	 * @param {ObjectType} targetObj
	 * @param {String} targetObjType
	 * @param {String} targetExpr
	 * @param {String} targetIdforExpr
	 * @param {String} oldIdforExpr
	 * @param {String} newIdforExpr
	 */
	static _updateExpressionString(srcObjType, targetObj, targetObjType, targetExpr, targetIdforExpr, oldIdforExpr, newIdforExpr) {
		var newExpr = ItemScanner.replaceIdForExpr(targetObjType, targetExpr, targetIdforExpr, srcObjType, oldIdforExpr, newIdforExpr);
		if (newExpr != null) {
			var realObjType = targetObj.getObjectType();
			if ("Calculation" == realObjType) {
				(targetObj).expression = newExpr;
			} else if ("Filter" == realObjType) {
				(targetObj).expression = newExpr;
			} else if ("QueryItem" == realObjType) {
				(targetObj).expression = newExpr;
			}
		}
	}

	static setIdentifier(obj, value, idforExprToNewExpr) {
		if (idforExprToNewExpr) {
			var candidates = [];
			var exprs = [];
			var types = [];
			var idforExprs = [];
			PropertySetter._collectCandidates(obj, candidates, exprs, types, idforExprs);
			for (var i = 0; i < candidates.length; ++i) {
				var newExpr = idforExprToNewExpr[idforExprs[i]];
				if (newExpr != null) {
					var objType = types[i];
					if ("Calculation" == objType) {
						var c = candidates[i];
						c.setExpression(newExpr);
					} else if ("Filter" == objType) {
						var f = candidates[i];
						f.setExpression(newExpr);
					} else if ("QueryItem" == objType) {
						var qi = candidates[i];
						qi.setExpression(newExpr);
					}
				}
			}
		}
		obj.setIdentifier(value);
	}

	static getExtractIdentifiersSpec(obj, value) {
		var oldIdForExpr = obj.idForExpression;
		var oldValue = obj.identifier;
		var module = MoserObject.getModuleObject(obj);
		if (!module || oldValue == null || oldIdForExpr == null || oldValue == value) {
			return null;
		}
		var objType = obj.getObjectType();
		var candidates = [];
		var exprs = [];
		var types = [];
		var idforExprs = [];
		PropertySetter._collectCandidates(obj, candidates, exprs, types, idforExprs);
		if (candidates.length==0) {
			return null;
		}
		return PropertySetter.buildSpec(oldIdForExpr, objType, value, exprs, types, idforExprs);
	}

	static _collectCandidates(obj, candidates, exprs, types, idforExprs) {
		var module = MoserObject.getModuleObject(obj);
		if (!module) {
			return;
		}
		var objType = obj.getObjectType();
		if ("Calculation" == objType || "Filter" == objType) {
			PropertySetter.collectCandidatesForGlobaleCalculationFilter(module, obj, candidates, exprs, types, idforExprs);
		} else if ("QuerySubject" == objType) {
			PropertySetter._collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, null);
		} else if ("QueryItem" == objType) {
			PropertySetter._collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, null);
		}
	}

	static _objectWithExpr(expr, idForExpr) {
		return expr != null && !(expr.length === 0) && idForExpr != null && !(idForExpr.length === 0);
	}

	/**
	 * @param {Module} module
	 * @param {ObjectType} obj
	 * @param {Array} candidates
	 * @param {Array} exprs
	 * @param {Array} types
	 * @param {Array} idforExprs
	 */
	static collectCandidatesForGlobaleCalculationFilter(module, obj, candidates, exprs, types, idforExprs) {
		var calcs = module.basicGetCalculation();
		if (calcs) {
			for (var __i_enFor0 = 0, __exp_enFor0 = calcs, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var c = __exp_enFor0[__i_enFor0];
				if (!(c === obj) && PropertySetter._objectWithExpr(c.expression, c.idForExpression)) {
					candidates.push(c);
					exprs.push(c.expression);
					types.push("Calculation");
					idforExprs.push(c.idForExpression);
				}
			}
		}
		var filters = module.basicGetFilter();
		if (filters) {
			for (var __i_enFor1 = 0, __exp_enFor1 = filters, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var f = __exp_enFor1[__i_enFor1];
				if (!(f === obj) && PropertySetter._objectWithExpr(f.expression, f.idForExpression)) {
					candidates.push(f);
					exprs.push(f.expression);
					types.push("Filter");
					idforExprs.push(f.idForExpression);
				}
			}
		}
	}

	/**
	 * get first level Query items / drag-able filters.
	 * @param {Array} items
	 * @return {Array}
	 */
	static getItemsWithQueryItemFilter(items) {
		var rtItems = [];
		if (!items) {
			return rtItems;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.getQueryItem() || item.getFilter()) {
				rtItems.push(item);
			} else if (item.getFolder()) {
				Array.prototype.push.apply(rtItems, PropertySetter.getItemsWithQueryItemFilter(item.getFolder().basicGetItem()));
			}
		}
		return rtItems;
	}

	/**
	 * Returns true if the moser object is an extended item of a shortcut or alias. Returns false if object does not belong to a shortcut or alias.
	 * @param {MoserObject} obj   moser object
	 * @return {boolean}  t/f
	 */
	static isExtendedItem(obj) {
		var qs = PropertySetter.getParentQuerySubject(obj);
		return PropertySetter.isExtensionOfParentShortcut(qs, obj);
	}

	/**
	 * Returns the query subject target of a shortcut or alias in the same data module.
	 * @param {QuerySubject} qs       query subject
	 * @return {QuerySubject}  target qs
	 */
	static getShortcutTargetInDataModule(qs) {
		if (PropertySetter.isShortcutOrAlias(qs, false)) {
			var module = MoserObject.getModuleObject(qs);
			var originalRef = qs.getOriginalRef();
			return PropertySetter._getQuerySubjectById(module, originalRef[0]);
		}
		return null;
	}

	/**
	 * Returns true if the moser object is an extended item of a shortcut or alias. Returns false if object does not belong to a shortcut or alias.
	 * @param {QuerySubject} qs    query subject
	 * @param {MoserObject} obj   moser object
	 * @return {boolean}  t/f
	 */
	static isExtensionOfParentShortcut(qs, obj) {
		if (!obj) {
			return false;
		}
		var objType = obj.getObjectType();
		if (PropertySetter.isShortcutOrAlias(qs, true) && ("QueryItem" == objType || "Filter" == objType || "Folder" == objType || "ItemHierarchy" == objType || "Calculation" == objType)) {
			var objectTypeObj = obj;
			return objectTypeObj.basicGetPropertyOverride() && !(objectTypeObj.basicGetPropertyOverride().length==0);
		}
		return false;
	}

	/**
	 * Given a shortcut and its target, assign the item normalization of the shortcut a copy of the target item normalization.
	 * @param {QuerySubject} shortcut
	 * @param {QuerySubject} target     query subject
	 * @param {boolean} bUndoable  adds to undo/redo stack if true
	 */
	static _setShortcutItemNormFromTarget(shortcut, target, bUndoable) {
		var idToTargetGrp = {};
		var idToShortcutGrp = {};
		var targetGroupIds = [];
		var targetItemNorm = target.getItemNormalization();
		var targetGroups = targetItemNorm.getItemNormalizationGroup();
		var shortcutItemNorm = shortcut.getItemNormalization();
		var shortcutGroups = shortcutItemNorm.getItemNormalizationGroup();
		for (var __i_enFor0 = 0, __exp_enFor0 = targetGroups, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var g = __exp_enFor0[__i_enFor0];
			idToTargetGrp[g.getIdentifier()] = g;
			targetGroupIds.push(g.getIdentifier());
		}
		for (var i = shortcutGroups.length - 1; i >= 0; --i) {
			var g = shortcutGroups[i];
			if (!idToTargetGrp[g.getIdentifier()]) {
				if (bUndoable) {
					shortcutItemNorm.removeItemNormalizationGroupAt(i);
				} else {
					shortcutGroups.splice(i, 1);
				}
			} else {
				idToShortcutGrp[g.getIdentifier()] = g;
			}
		}
		for (var i = 0; i < targetGroupIds.length; ++i) {
			try {
				var id = targetGroupIds[i];
				if (idToShortcutGrp[id]) {
					var group = idToShortcutGrp[id];
					var shortcutAttrs = group.getAttribute();
					if (bUndoable) {
						for (var j = group.getAttribute().length - 1; j >= 0; --j) {
							group.removeAttributeAt(j);
						}
					} else {
						shortcutAttrs.length = 0;
					}
					var targetAttrs = idToTargetGrp[id].getAttribute();
					for (var __i_enFor1 = 0, __exp_enFor1 = targetAttrs, __len_enFor1 = __exp_enFor1.length;
							__i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var attr = __exp_enFor1[__i_enFor1];
						var attrClone = attr.clone();
						if (bUndoable) {
							group.addAttribute(attr);
						} else {
							attrClone._parent = group;
							shortcutAttrs.push(attrClone);
						}
					}
				} else {
					var groupClone = idToTargetGrp[id].clone();
					PropertySetter.set(groupClone, 161, EditModeType.RO, false);
					if (bUndoable) {
						shortcutItemNorm.addItemNormalizationGroupAt(i, groupClone);
					} else {
						groupClone._parent = shortcutItemNorm;
						shortcutGroups.splice(i, 0, groupClone);
					}
				}
			} catch (e) {
				throw e;
			}

		}
	}

	/**
	 * Given a shortcut populate a set have target ids and a list of extended items.
	 * @param {QuerySubject} shortcut
	 * @param {Set} targetQIIds
	 * @param {Array} extendedQIList
	 */
	static _populateExtQIList(shortcut, targetQIIds, extendedQIList) {
		for (var __i_enFor0 = 0, __exp_enFor0 = PropertySetter.getQueryItems(shortcut), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (PropertySetter.isExtensionOfParentShortcut(shortcut, item)) {
				extendedQIList.push(item);
			} else {
				targetQIIds[item.getIdentifier()] = 1;
			}
		}
	}

	static _collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, oldQSId) {
		var tp = obj.getObjectType();
		var qs;
		var oldQSIdforExpr;
		if ("QuerySubject" == tp) {
			qs = obj;
			if (oldQSId != null) {
				oldQSIdforExpr = oldQSId;
			} else {
				oldQSIdforExpr = qs.idForExpression;
			}
		} else if ("QueryItem" == tp || "Filter" == tp) {
			qs = PropertySetter.getParentQuerySubject(obj);
			oldQSIdforExpr = qs.idForExpression;
		} else {
			return;
		}
		if (oldQSIdforExpr == null) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = PropertySetter.getItemsWithQueryItemFilter(qs.basicGetItem()), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			var qi = item.getQueryItem();
			if (qi) {
				if (qi === obj || !(PropertySetter._objectWithExpr(qi.expression, qi.idForExpression))) {
					continue;
				}
				candidates.push(qi);
				exprs.push(qi.expression);
				types.push("QueryItem");
				idforExprs.push(qi.idForExpression);
			} else {
				var df = item.getFilter();
				if (df === obj || PropertySetter._objectWithExpr(df.expression, df.idForExpression)) {
					candidates.push(df);
					exprs.push(df.expression);
					types.push("QueryItem");
					idforExprs.push(df.idForExpression);
				}
			}
		}
		var embeddedFilters = qs.basicGetFilter();
		if (embeddedFilters) {
			for (var __i_enFor1 = 0, __exp_enFor1 = embeddedFilters, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var ef = __exp_enFor1[__i_enFor1];
				if (PropertySetter._objectWithExpr(ef.expression, ef.idForExpression)) {
					candidates.push(ef);
					exprs.push(ef.expression);
					types.push("QueryItem");
					idforExprs.push(ef.idForExpression);
				}
			}
		}
		var allQSs = module.basicGetQuerySubject();
		if (allQSs) {
			for (var __i_enFor2 = 0, __exp_enFor2 = allQSs, __len_enFor2 = __exp_enFor2.length;
					__i_enFor2 < __len_enFor2; ++__i_enFor2) {
				var aQS = __exp_enFor2[__i_enFor2];
				if (aQS === qs || !(PropertySetter._hasReference(aQS, qs, oldQSIdforExpr))) {
					continue;
				}
				for (var __i_enFor3 = 0, __exp_enFor3 = PropertySetter.getItemsWithQueryItemFilter(aQS.basicGetItem()), __len_enFor3 = __exp_enFor3.length;
						__i_enFor3 < __len_enFor3; ++__i_enFor3) {
					var item = __exp_enFor3[__i_enFor3];
					var qi = item.getQueryItem();
					if (qi && qi.regularAggregate != RegularAggregateType.CALCULATED && PropertySetter._objectWithExpr(qi.expression, qi.idForExpression)) {
						candidates.push(qi);
						exprs.push(qi.expression);
						types.push("QueryItem");
						idforExprs.push(qi.idForExpression);
					}
				}
			}
		}
		var calcs = module.basicGetCalculation();
		if (calcs) {
			for (var __i_enFor4 = 0, __exp_enFor4 = calcs, __len_enFor4 = __exp_enFor4.length;
					__i_enFor4 < __len_enFor4; ++__i_enFor4) {
				var c = __exp_enFor4[__i_enFor4];
				if (PropertySetter._objectWithExpr(c.expression, c.idForExpression)) {
					candidates.push(c);
					exprs.push(c.expression);
					types.push("Calculation");
					idforExprs.push(c.idForExpression);
				}
			}
		}
		var filters = module.basicGetFilter();
		if (filters) {
			for (var __i_enFor5 = 0, __exp_enFor5 = filters, __len_enFor5 = __exp_enFor5.length;
					__i_enFor5 < __len_enFor5; ++__i_enFor5) {
				var f = __exp_enFor5[__i_enFor5];
				if (PropertySetter._objectWithExpr(f.expression, f.idForExpression)) {
					candidates.push(f);
					exprs.push(f.expression);
					types.push("Filter");
					idforExprs.push(f.idForExpression);
				}
			}
		}
	}

	static _hasReference(aQS, qs, oldQSId) {
		var refs = aQS.basicGetRef();
		if (refs && refs.indexOf(oldQSId)> -1) {
			return true;
		}
		var joinOp = aQS.getJoinOperation();
		if (joinOp) {
			refs = joinOp.basicGetQueryRef();
			if (refs && refs.indexOf(oldQSId)> -1) {
				return true;
			}
		}
		return false;
	}

	static buildSpec(oldIdForExpr, objType, newId, exprs, types, idforExprs) {
		return "{" + PropertySetter._wrapQuote("moserFunctionType") + ":" + PropertySetter._wrapQuote("extractIdentifiers") + "," + PropertySetter._buildExpressions(exprs) + "," + PropertySetter._buildFeedback(oldIdForExpr, objType, newId, types, idforExprs) + "}";
	}

	static _buildExpressions(exprs) {
		var sb1 = "";
		for (var i = 0; i < exprs.length; ++i) {
			if (i > 0) {
				sb1+=(",");
			}
			sb1+=(PropertySetter._wrapQuote(exprs[i]));
		}
		return PropertySetter._wrapQuote("expressions") + ":[" + sb1 + "]";
	}

	static _buildFeedback(oldIdForExpr, objType, newId, types, idforExprs) {
		var sb1 = "";
		for (var i = 0; i < idforExprs.length; ++i) {
			if (i > 0) {
				sb1+=(",");
			}
			sb1+=("{");
			sb1+=(PropertySetter._wrapSlashQuote("idForExpression"));
			sb1+=(":");
			sb1+=(PropertySetter._wrapSlashQuote(idforExprs[i]));
			sb1+=(",");
			sb1+=(PropertySetter._wrapSlashQuote("type"));
			sb1+=(":");
			sb1+=(PropertySetter._wrapSlashQuote(types[i]));
			sb1+=("}");
		}
		return PropertySetter._wrapQuote("feedback") + ":" + PropertySetter._wrapQuote("{" + PropertySetter._wrapSlashQuote("idForExpression") + ":" + PropertySetter._wrapSlashQuote(oldIdForExpr) + "," + PropertySetter._wrapSlashQuote("type") + ":" + PropertySetter._wrapSlashQuote(objType) + "," + PropertySetter._wrapSlashQuote("newIdentifier") + ":" + PropertySetter._wrapSlashQuote(newId) + "," + PropertySetter._wrapSlashQuote("expressions") + ":[" + sb1 + "]}");
	}

	static _wrapQuote(s) {
		return "\"" + s + "\"";
	}

	static _wrapSlashQuote(s) {
		return "\\\"" + s + "\\\"";
	}

	static cleanQuerySubjectItemNormalization(qs, existingQI) {
		var itemNorm = qs.itemNormalization;
		if (!itemNorm) {
			return false;
		}
		var grps = itemNorm.itemNormalizationGroup;
		if (!grps || grps.length==0) {
			return false;
		}
		if (existingQI.length==0) {
			qs.itemNormalization = null;
			return true;
		}
		var bChanged = false;
		var lst = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = grps, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var g = __exp_enFor0[__i_enFor0];
			lst.push(g);
		}
		for (var __i_enFor1 = 0, __exp_enFor1 = lst, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var ag = __exp_enFor1[__i_enFor1];
			var bDelGrp = false;
			var attrs = ag.attribute;
			var k = ag.key;
			if (attrs && !(attrs.length==0)) {
				var sz = attrs.length;
				for (var i = sz - 1; i >= 0; --i) {
					if (!(existingQI.indexOf(attrs[i].itemRef)> -1)) {
						bChanged = true;
						attrs.splice(i, 1);
					}
				}
			}
			if (k) {
				bDelGrp = !(existingQI.indexOf(k.itemRef)> -1);
			} else {
				bDelGrp = !attrs || attrs.length==0;
			}
			if (bDelGrp) {
				bChanged = true;
				var gpId = ag.identifier;
				var paranetGrps = ag.parentGroupRef;
				var idx = grps.indexOf(ag);
				if (idx >= 0) {
					grps.splice(idx, 1);
				}
				for (var __i_enFor2 = 0, __exp_enFor2 = grps, __len_enFor2 = __exp_enFor2.length;
						__i_enFor2 < __len_enFor2; ++__i_enFor2) {
					var otherGrp = __exp_enFor2[__i_enFor2];
					var otherParanetGrps = otherGrp.parentGroupRef;
					if (otherParanetGrps && !(otherParanetGrps.length==0) && otherParanetGrps.indexOf(gpId)> -1) {
						idx = otherParanetGrps.indexOf(gpId);
						if (idx >= 0) {
							otherParanetGrps.splice(idx, 1);
						}
						if (paranetGrps) {
							for (var __i_enFor3 = 0, __exp_enFor3 = paranetGrps, __len_enFor3 = __exp_enFor3.length;
									__i_enFor3 < __len_enFor3; ++__i_enFor3) {
								var sg = __exp_enFor3[__i_enFor3];
								if (!(otherParanetGrps.indexOf(sg)> -1)) {
									otherParanetGrps.push(sg);
								}
							}
						}
					}
				}
			}
		}
		if (grps.length==0) {
			bChanged = true;
			qs.itemNormalization = null;
		}
		return bChanged;
	}

	/**
	 * add query item to item normalization.
	 * @param {QuerySubject} qs
	 * @param {QueryItem} queryItem
	 * @param {ObjectFactory} objectFactory
	 */
	static addQueryItemToItemNormalization(qs, queryItem, objectFactory) {
		PropertySetter.addQueryItemToItemNormalizationGroup(qs.getIdentifier(), qs.getItemNormalization(), queryItem, objectFactory, true);
	}

	/**
	 * @param {QueryItem} queryItem
	 * @param {ItemNormalizationGroupType} pkGrp
	 * @param {ObjectFactory} objectFactory
	 * @param {boolean} bUndoable
	 */
	static _addQueryItemToGroupIfAbsent(queryItem, pkGrp, objectFactory, bUndoable) {
		if (PropertySetter._isInItemNormalizationGroupType(queryItem.getIdentifier(), pkGrp)) {
			return;
		}
		PropertySetter._addNewAttributeToGroup(objectFactory, pkGrp, queryItem, bUndoable);
	}

	/**
	 * Returns true if query subject is a shortcut or alias.
	 * @param {QuerySubject} qs              query subject
	 * @param {boolean} includeInvalid  query subject can point to an invalid target
	 * @return {boolean}  t/f
	 */
	static isShortcutOrAlias(qs, includeInvalid) {
		if (!qs) {
			return false;
		}
		if (!qs.getTreatAs()) {
			return false;
		}
		if (!qs.getInstanceType()) {
			return false;
		}
		if (includeInvalid) {
			return qs.getInstanceType() == InstanceType.REFERENCE || qs.getInstanceType() == InstanceType.MISSING;
		}
		return qs.getInstanceType() == InstanceType.REFERENCE;
	}

	/**
	 * @param {String} qsId
	 * @param {QueryItem} queryItem
	 * @param {Array} idList
	 * @param {Map} allIds
	 * @return {boolean}
	 */
	static getIdsInQueryItemExpression(qsId, queryItem, idList, allIds) {
		var ids = ItemScanner.collectIdentifiers(queryItem.getExpression());
		for (var __i_enFor0 = 0, __exp_enFor0 = ids, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var id = __exp_enFor0[__i_enFor0];
			if (!(PropertySetter.addQueryItemIdParts(idList, id, allIds, qsId))) {
				return false;
			}
		}
		return true;
	}

	/**
	 * add query item to item normalization group.
	 * @param {String} qsId
	 * @param {ItemNormalizationType} itemNormalization
	 * @param {QueryItem} queryItem
	 * @param {ObjectFactory} objectFactory
	 * @param {boolean} bUndoable
	 */
	static addQueryItemToItemNormalizationGroup(qsId, itemNormalization, queryItem, objectFactory, bUndoable) {
		if (!itemNormalization || !itemNormalization.itemNormalizationGroup || itemNormalization.itemNormalizationGroup.length==0) {
			return;
		}
		if (RegularAggregateType.CALCULATED == queryItem.regularAggregate) {
			return;
		}
		var dummyGrp;
		var realGrps = [];
		var idToGrp = {};
		for (var __i_enFor0 = 0, __exp_enFor0 = itemNormalization.itemNormalizationGroup, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var g = __exp_enFor0[__i_enFor0];
			if (g.identifier == null) {
				return;
			}
			if (PropertySetter._isInItemNormalizationGroupType(queryItem.getIdentifier(), g)) {
				return;
			}
			idToGrp[g.identifier] = g;
			if ("dummyGroup4ShortcutAlias" == g.identifier) {
				dummyGrp = g;
			} else {
				realGrps.push(g);
			}
		}
		var pkGrp = PropertySetter._getSimplePrimaryKeyGroup(realGrps, idToGrp);
		if (pkGrp && realGrps.length == 1) {
			PropertySetter._addQueryItemToGroupIfAbsent(queryItem, pkGrp, objectFactory, bUndoable);
			return;
		}
		var allIds = {};
		var idList = [];
		var b = PropertySetter.getIdsInQueryItemExpression(qsId, queryItem, idList, allIds);
		if (!b && !(PropertySetter.isShortcutOrAlias(PropertySetter.getParentQuerySubject(itemNormalization), false))) {
			return;
		}
		var nIds = idList.length;
		if (nIds == 0 || !b && PropertySetter.isShortcutOrAlias(PropertySetter.getParentQuerySubject(itemNormalization), false)) {
			PropertySetter._addToPKOrDummyGroup(pkGrp, itemNormalization, dummyGrp, queryItem, objectFactory, bUndoable);
			return;
		}
		for (var __i_enFor1 = 0, __exp_enFor1 = realGrps, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var grp = __exp_enFor1[__i_enFor1];
			var idsInGrp = [];
			PropertySetter._getNeededItemRefInGroup(idsInGrp, grp, allIds);
			if (idsInGrp.length == nIds || !(idsInGrp.length==0) && PropertySetter._checkIfSingleBranch(nIds, grp, idsInGrp, allIds, idToGrp)) {
				PropertySetter._addQueryItemToGroupIfAbsent(queryItem, grp, objectFactory, bUndoable);
				return;
			}
		}
		PropertySetter._addToPKOrDummyGroup(pkGrp, itemNormalization, dummyGrp, queryItem, objectFactory, bUndoable);
	}

	/**
	 * @param {int} nIds
	 * @param {ItemNormalizationGroupType} grp
	 * @param {Array} idsInGrp
	 * @param {Object} allIds
	 * @param {Object} idToGrp
	 * @return {boolean}
	 */
	static _checkIfSingleBranch(nIds, grp, idsInGrp, allIds, idToGrp) {
		var parentGrps = grp.parentGroupRef;
		if (!parentGrps || parentGrps.length != 1) {
			return false;
		}
		var pGrp = idToGrp[parentGrps[0]];
		PropertySetter._getNeededItemRefInGroup(idsInGrp, pGrp, allIds);
		if (idsInGrp.length == nIds) {
			return true;
		}
		return PropertySetter._checkIfSingleBranch(nIds, pGrp, idsInGrp, allIds, idToGrp);
	}

	/**
	 * Returns true if the identifier exists as an item ref in the group
	 * @param {String} identifier  item ref
	 * @param {ItemNormalizationGroupType} grp 		 item normalization group type
	 */
	static _isInItemNormalizationGroupType(identifier, grp) {
		if (identifier == null || !grp) {
			return false;
		}
		var key = grp.getKey();
		if (key && identifier == key.getItemRef()) {
			return true;
		}
		var attributeList = grp.basicGetAttribute();
		if (!grp.basicGetAttribute()) {
			return false;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = attributeList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var attribute = __exp_enFor0[__i_enFor0];
			if (identifier == attribute.getItemRef()) {
				return true;
			}
		}
		return false;
	}

	/**
	 * @param {ItemNormalizationGroupType} pkGrp
	 * @param {ItemNormalizationType} itemNormalization
	 * @param {ItemNormalizationGroupType} dummyGrp
	 * @param {QueryItem} queryItem
	 * @param {ObjectFactory} objectFactory
	 * @param {boolean} bUndoable
	 */
	static _addToPKOrDummyGroup(pkGrp, itemNormalization, dummyGrp, queryItem, objectFactory, bUndoable) {
		var grp = pkGrp;
		if (!grp && PropertySetter.isShortcutOrAlias(PropertySetter.getParentQuerySubject(itemNormalization), false)) {
			grp = dummyGrp;
			if (!grp) {
				grp = objectFactory.createItemNormalizationGroupType();
				PropertySetter.set(grp, 161, EditModeType.RO, false);
				grp.identifier = "dummyGroup4ShortcutAlias";
				if (bUndoable) {
					itemNormalization.addItemNormalizationGroup(grp);
				} else {
					itemNormalization.itemNormalizationGroup.push(grp);
				}
			}
		}
		if (grp) {
			PropertySetter._addQueryItemToGroupIfAbsent(queryItem, grp, objectFactory, bUndoable);
		}
	}

	/**
	 * @param {Array} idsInGrp
	 * @param {ItemNormalizationGroupType} grp
	 * @param {Object} allIds
	 */
	static _getNeededItemRefInGroup(idsInGrp, grp, allIds) {
		if (grp.key && grp.key.itemRef != null && allIds.hasOwnProperty(grp.key.itemRef) && !(idsInGrp.indexOf(grp.key.itemRef)> -1)) {
			idsInGrp.push(grp.key.itemRef);
		}
		if (!grp.attribute || grp.attribute.length==0) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = grp.attribute, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var a = __exp_enFor0[__i_enFor0];
			if (a.itemRef != null && allIds.hasOwnProperty(a.itemRef) && !(idsInGrp.indexOf(a.itemRef)> -1)) {
				idsInGrp.push(a.itemRef);
			}
		}
	}

	/**
	 * add a new attribute to the group.
	 * @param {ObjectFactory} objectFactory
	 * @param {ItemNormalizationGroupType} pkGrp
	 * @param {QueryItem} queryItem
	 * @param {boolean} bUndoable
	 */
	static _addNewAttributeToGroup(objectFactory, pkGrp, queryItem, bUndoable) {
		var newAttr = objectFactory.createItemNormalizationGroupTypeAttribute();
		newAttr.itemRef = queryItem.identifier;
		newAttr.sqlOperator = SqlOperatorType.MINIMUM;
		if (bUndoable) {
			pkGrp.addAttribute(newAttr);
		} else {
			pkGrp.getAttribute().push(newAttr);
			newAttr._parent = pkGrp;
		}
	}

	static _getSimplePrimaryKeyGroup(grps, idToGrp) {
		if (grps.length == 1) {
			var g = grps[0];
			if (g.key && g.key.getKeyConstraint() == KeyConstraintType.UNIQUE) {
				return g;
			}
			return null;
		}
		var nUniqueGrps = 0;
		var pkGrp;
		for (var __i_enFor0 = 0, __exp_enFor0 = grps, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var g = __exp_enFor0[__i_enFor0];
			if (g.key && g.key.keyConstraint == KeyConstraintType.UNIQUE) {
				nUniqueGrps++;
				if (!pkGrp || g.key.keyComposition == KeyCompositionType.INDEPENDENT) {
					pkGrp = g;
				}
			}
		}
		if (!pkGrp || pkGrp.key.keyComposition == KeyCompositionType.INDEPENDENT) {
			return pkGrp;
		}
		if (nUniqueGrps > 1) {
			return null;
		}
		var nChain = 1;
		var parentGrps = pkGrp.parentGroupRef;
		while (parentGrps && !(parentGrps.length==0)) {
			if (parentGrps.length > 1) {
				return null;
			}
			nChain++;
			parentGrps = idToGrp[parentGrps[0]].parentGroupRef;
		}
		if (nChain != grps.length) {
			return null;
		}
		return pkGrp;
	}

	/**
	 * @param {BaseMoserObject} obj
	 * @return {boolean}  false if id is invalid.
	 */
	static _addIdFromJSONObject(idList, obj, allIds, qsId) {
		if (obj instanceof Object) {
			var jObj = obj;
			var id = jObj["id"];
			if (id != null && !(id.length === 0) && id.indexOf(" ") == -1) {
				return PropertySetter._addQueryItemId(idList, id, allIds, qsId);
			}
		}
		return true;
	}

	/**
	 * get ids from JSON property value (defined by MUI).
	 * @param {Map} allIds 	return all Ids.
	 * @param {Object} jFunc 		JSON.
	 */
	static _getIdsFromPropertyJSONValue(idList, allIds, jFunc, qsId) {
		if (!jFunc) {
			return false;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = Object.keys(jFunc), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var key = __exp_enFor0[__i_enFor0];
			var value = jFunc[key];
			if ((typeof value === "array" || value instanceof Array)) {
				for (var __i_enFor1 = 0, __exp_enFor1 = value, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var obj = __exp_enFor1[__i_enFor1];
					if (!(PropertySetter._addIdFromJSONObject(idList, obj, allIds, qsId))) {
						return false;
					}
				}
			} else {
				if (!(PropertySetter._addIdFromJSONObject(idList, value, allIds, qsId))) {
					return false;
				}
			}
		}
		return true;
	}

	static _addQueryItemId(idList, basedObj, allIds, qsId) {
		var parts = basedObj.split(new RegExp("\\."));
		return PropertySetter.addQueryItemIdParts(idList, parts, allIds, qsId);
	}

	static addQueryItemIdParts(idList, parts, allIds, qsId) {
		if (parts.length == 1) {
			if (!(allIds.hasOwnProperty(parts[0]))) {
				allIds[parts[0]] = parts[0];
				idList.push(parts[0]);
			}
			return true;
		}
		if (parts.length >= 2) {
			if (parts[0] == qsId) {
				if (parts.length == 2 && !(allIds.hasOwnProperty(parts[1]))) {
					allIds[parts[1]] = parts[1];
					idList.push(parts[1]);
				}
				return true;
			}
		}
		return false;
	}

	/**
	 * @param {Array} newGrps
	 * @param {Map} srcGrpIdToGrpMap
	 */
	static relinkItemNormalizationGroups(newGrps, srcGrpIdToGrpMap) {
		var groupIdSet = {};
		for (var __i_enFor0 = 0, __exp_enFor0 = newGrps, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var g = __exp_enFor0[__i_enFor0];
			groupIdSet[g.getIdentifier()] = 1;
		}
		for (var __i_enFor1 = 0, __exp_enFor1 = newGrps, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var grp = __exp_enFor1[__i_enFor1];
			var srcGrp = srcGrpIdToGrpMap[grp.getIdentifier()];
			var parents = srcGrp.parentGroupRef;
			if (!parents || parents.length==0) {
				grp.parentGroupRef = null;
				continue;
			}
			var newParents = [];
			var newParentsSet = {};
			for (var __i_enFor2 = 0, __exp_enFor2 = parents, __len_enFor2 = __exp_enFor2.length;
					__i_enFor2 < __len_enFor2; ++__i_enFor2) {
				var pId = __exp_enFor2[__i_enFor2];
				PropertySetter._getNewParentGroupId(pId, groupIdSet, srcGrpIdToGrpMap, newParents, newParentsSet);
			}
			if (newParents.length==0) {
				grp.parentGroupRef = null;
			} else {
				grp.parentGroupRef = newParents;
			}
		}
	}

	/**
	 * @param {String} gId
	 * @param {Set} groupIdSet
	 * @param {Map} srcGrpIdToGrpMap
	 * @param {Array} rtLst
	 * @param {Set} rtSet
	 * @return {void}
	 */
	static _getNewParentGroupId(gId, groupIdSet, srcGrpIdToGrpMap, rtLst, rtSet) {
		if (gId == null || gId.length === 0) {
			return;
		}
		if (groupIdSet.hasOwnProperty(gId)) {
			if (!(rtSet.hasOwnProperty(gId))) {
				rtLst.push(gId);
				rtSet[gId] = 1;
			}
			return;
		}
		var sGrp = srcGrpIdToGrpMap[gId];
		if (!sGrp.parentGroupRef || sGrp.parentGroupRef.length==0) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = sGrp.parentGroupRef, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var pId = __exp_enFor0[__i_enFor0];
			PropertySetter._getNewParentGroupId(pId, groupIdSet, srcGrpIdToGrpMap, rtLst, rtSet);
		}
	}

	/**
	 * @param {MoserObject} aObj
	 * @param {int} featureID
	 * @param {BaseMoserObject} value
	 */
	static setMoserObject(aObj, featureID, value) {
		if (!aObj) {
			return;
		}
		var objType = aObj.getObjectType();
		if ("Key" == objType) {
			var key = aObj;
			switch (featureID) {
			case 285:
				key.keyConstraint = value;
				break;
			case 286:
				key.keyComposition = value;
				break;
			default:
				break;
			}
			return;
		}
		if ("Attribute" == objType) {
			var attr = aObj;
			if (featureID == 287) {
				attr.sqlOperator = value;
			}
			return;
		}
		if ("PropertyType" == objType) {
			var prop = aObj;
			if (featureID == 130) {
				prop.value = value;
			}
			return;
		}
		if ("FacetType" == objType) {
			var facet = aObj;
			if (98 == featureID) {
				facet.enabled = value;
			} else if (26 == featureID) {
				facet.sortList = value;
			}
			return;
		}
		if ("SortItem" == objType) {
			var sortItem = aObj;
			if (6 == featureID) {
				sortItem.ref = value;
			} else if (295 == featureID) {
				sortItem.order = value;
			} else if (267 == featureID) {
				sortItem.nullPlacement = value;
			}
			return;
		}
	}

	/**
	 * Populates the override information of the  data source override object. Uses private access to the override fields.
	 * @param {DataSourceOverride} dataSourceOverride  	 override object
	 * @param {String} originalCMDataSource
	 * @param {String} originalCatalog
	 * @param {String} originalSchema
	 * @param {boolean} isOverrideCMDataSource
	 * @param {boolean} isOverrideCatalog
	 * @param {boolean} isOverrideSchema
	 */
	static populateOverrideFields(dataSourceOverride, originalCMDataSource, originalCatalog, originalSchema, isOverrideCMDataSource, isOverrideCatalog, isOverrideSchema) {
		if (!dataSourceOverride) {
			return;
		}
		if (dataSourceOverride.cmDataSource == null && !isOverrideCMDataSource) {
			dataSourceOverride.setCmDataSource(originalCMDataSource);
		}
		if (dataSourceOverride.catalog == null && !isOverrideCatalog) {
			dataSourceOverride.setCatalog(originalCatalog);
		}
		if (dataSourceOverride.schema == null && !isOverrideSchema) {
			dataSourceOverride.setSchema(originalSchema);
		}
	}

	static isDataSourceOverrideEmpty(dataSourceOverride) {
		if (!dataSourceOverride) {
			return true;
		}
		return dataSourceOverride.originalCMDataSource == null && dataSourceOverride.cmDataSource == null && dataSourceOverride.originalCatalog == null && dataSourceOverride.catalog == null && dataSourceOverride.originalSchema == null && dataSourceOverride.schema == null && !(dataSourceOverride.isOverrideCMDataSource()) && !(dataSourceOverride.isOverrideCatalog()) && !(dataSourceOverride.isOverrideSchema());
	}

	static setTaxonomy(taxonomyType, featureID, value, bNotify) {
		if (!taxonomyType) {
			return;
		}
		var oldValue = taxonomyType.get(featureID);
		switch (featureID) {
		case 206:
			taxonomyType.clazz = value;
			break;
		case 205:
			taxonomyType.domain = value;
			break;
		case 207:
			taxonomyType.family = value;
			break;
		default:
			break;
		}
		if (bNotify) {
			var notification = new Notification(3, taxonomyType, featureID, oldValue, value, -1);
			taxonomyType.notify(notification, false);
		}
	}

	/**
	 * Sets a property of an ObjectType without adding propertyOverride.
	 * @param {ObjectType} obj        object to set
	 * @param {int} featureID  feature
	 * @param {BaseMoserObject} value      value to set to
	 * @param {boolean} bNotify    notify listener for undo/redo.
	 * @return {void}
	 */
	static set(obj, featureID, value, bNotify) {
		if (!obj) {
			return;
		}
		var objType = obj.getObjectType();
		var oldValue;
		if ("QueryItem" == objType) {
			var qi = obj;
			oldValue = qi.get(featureID);
			switch (featureID) {
			case 183:
				qi.minimumValue = value;
				break;
			case 186:
				qi.numberOfNullValues = value;
				break;
			case 190:
				qi.rootMember = value;
				break;
			case 188:
				qi.hierarchyHasMultipleRoots = value;
				break;
			case 187:
				qi.orderedValues = value;
				break;
			case 184:
				qi.maximumValue = value;
				break;
			case 185:
				qi.numberOfDistinctValues = value;
				break;
			case 5:
				qi.expression = value;
				break;
			case 201:
				qi.role = value;
				break;
			case 141:
				qi.nullable = value;
				break;
			case 25:
				qi.sourceCategory = value;
				break;
			case 196:
				qi.highlevelDatatype = value;
				break;
			case 9:
				qi.instanceType = value;
				break;
			case 192:
				qi.usage = value;
				break;
			case 193:
				qi.format = value;
				break;
			case 200:
				qi.aggregateMode = value;
				break;
			case 6:
				qi.ref = value;
				break;
			case 140:
				qi.datatype = value;
				break;
			case 194:
				qi.regularAggregate = value;
				break;
			case 197:
				qi.facetDefinition = value;
				break;
			case 195:
				qi.datatypeCategory = value;
				break;
			case 202:
				qi.promptInfo = value;
				break;
			default:
				break;
			}
		}
		if ("Calculation" == objType) {
			var calc = obj;
			oldValue = calc.get(featureID);
			switch (featureID) {
			case 5:
				calc.expression = value;
				break;
			case 201:
				calc.role = value;
				break;
			case 141:
				calc.nullable = value;
				break;
			case 25:
				calc.sourceCategory = value;
				break;
			case 196:
				calc.highlevelDatatype = value;
				break;
			case 9:
				calc.instanceType = value;
				break;
			case 192:
				calc.usage = value;
				break;
			case 193:
				calc.format = value;
				break;
			case 200:
				calc.aggregateMode = value;
				break;
			case 6:
				calc.ref = value;
				break;
			case 140:
				calc.datatype = value;
				break;
			case 194:
				calc.regularAggregate = value;
				break;
			case 197:
				calc.facetDefinition = value;
				break;
			case 195:
				calc.datatypeCategory = value;
				break;
			case 202:
				calc.promptInfo = value;
				break;
			default:
				break;
			}
		}
		if ("Filter" == objType) {
			var filter = obj;
			oldValue = filter.get(featureID);
			switch (featureID) {
			case 6:
				filter.ref = value;
				break;
			case 5:
				filter.expression = value;
				break;
			case 166:
				filter.postAutoAggregation = value;
				break;
			case 9:
				filter.instanceType = value;
				break;
			default:
				break;
			}
		}
		if ("QuerySubject" == objType) {
			var qs = obj;
			oldValue = qs.get(featureID);
			switch (featureID) {
			case 15:
				qs.generateSQL = value;
				break;
			case 25:
				qs.sourceCategory = value;
				break;
			case 23:
				qs.queryOperation = value;
				break;
			case 13:
				qs.shortcutTargetQuerySubjectRef = value;
				break;
			case 19:
				qs.querySubjectUsage = value;
				break;
			case 21:
				qs.selectListControl = value;
				break;
			case 16:
				qs.useInJoinPath = value;
				break;
			case 26:
				qs.sortList = value;
				break;
			case 8:
				qs.classifier = value;
				break;
			case 18:
				qs.rowCount = value;
				break;
			case 12:
				qs.itemNormalization = value;
				break;
			case 20:
				qs.useLocalCache = value;
				break;
			case 22:
				qs.sqlQuery = value;
				break;
			case 9:
				qs.instanceType = value;
				break;
			case 24:
				qs.joinOperation = value;
				break;
			case 28:
				qs.treatAs = value;
				break;
			case 17:
				qs.numberOfRows = value;
				break;
			case 27:
				qs.dataCacheExpiry = value;
				break;
			default:
				break;
			}
		}
		if (oldValue == null) {
			oldValue = obj.get(featureID);
		}
		switch (featureID) {
		case 91:
			obj.identifier = value;
			break;
		case 127:
			obj.hidden = value;
			break;
		case 161:
			obj.editMode = value;
			break;
		case 126:
			obj.description = value;
			break;
		case 158:
			obj.comment = value;
			break;
		case 157:
			obj.label = value;
			break;
		case 159:
			obj.screenTip = value;
			break;
		case 129:
			obj.idForExpression = value;
			break;
		case 163:
			obj.originalLabel = value;
			break;
		case 162:
			obj.originalDescription = value;
			break;
		case 164:
			obj.originalScreenTip = value;
			break;
		default:
			break;
		}
		if (bNotify) {
			var notification = new Notification(3, obj, featureID, oldValue, value, -1);
			obj.notify(notification, false);
		}
	}

	/**
	 * get used Ids.
	 * @param {Array} props
	 * @param {Set} type
	 * @param {String} expr
	 * @return {Array}
	 */
	static getUsedIds(props, type, expr) {
		var rt = [];
		var bHasIds = false;
		if (props && !(props.length==0)) {
			for (var __i_enFor0 = 0, __exp_enFor0 = props, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var p = __exp_enFor0[__i_enFor0];
				var nm = p.getName();
				if (nm == null || !(nm.startsWith("_MUI_"))) {
					continue;
				}
				var jMUIProp = PropertySetter._parseStringToJSONObjectNoThrow(p.getValue());
				if (!jMUIProp) {
					continue;
				}
				if (PropertySetter._getUsedIdsFromJSON(jMUIProp, type, rt)) {
					bHasIds = true;
				}
			}
		}
		if (!bHasIds && expr != null && !(expr.length === 0)) {
			rt = ItemScanner.collectIdentifiers(expr);
		}
		return rt;
	}

	/**
	 * get id from JSON
	 * @param {Object} jMUIProp
	 * @param {Set} tp
	 * @param {Array} rt
	 * @return {boolean}
	 */
	static _getUsedIdsFromJSON(jMUIProp, tp, rt) {
		var b = false;
		var id = jMUIProp["id"];
		var type = jMUIProp["type"];
		if (id != null && !(id.length === 0) && type != null && !(type.length === 0)) {
			b = true;
			if (tp.hasOwnProperty(type)) {
				var parts = id.split(new RegExp("\\."));
				rt.push(parts);
			}
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = Object.keys(jMUIProp), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var key = __exp_enFor0[__i_enFor0];
			var value = jMUIProp[key];
			if ((typeof value === "array" || value instanceof Array)) {
				for (var __i_enFor1 = 0, __exp_enFor1 = value, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var obj = __exp_enFor1[__i_enFor1];
					if (obj instanceof Object && PropertySetter._getUsedIdsFromJSON(obj, tp, rt)) {
						b = true;
					}
				}
			} else if (value instanceof Object && PropertySetter._getUsedIdsFromJSON(value, tp, rt)) {
				b = true;
			}
		}
		return b;
	}

	/**
	 * Returns a list of all query items from in an ItemType
	 * @param {Array} items
	 * @return {Array}  List<QueryItem>
	 */
	static _getQueryItems$0(items) {
		var qItems = [];
		if (!items) {
			return qItems;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.getQueryItem()) {
				qItems.push(item.getQueryItem());
				Array.prototype.push.apply(qItems, PropertySetter._getQueryItems$0(item.getQueryItem().basicGetItem()));
			} else if (item.getFolder()) {
				Array.prototype.push.apply(qItems, PropertySetter._getQueryItems$0(item.getFolder().basicGetItem()));
			} else if (item.getCalculation()) {
				Array.prototype.push.apply(qItems, PropertySetter._getQueryItems$0(item.getCalculation().basicGetItem()));
			} else if (item.getNamedSet()) {
				Array.prototype.push.apply(qItems, PropertySetter._getQueryItems$0(item.getNamedSet().basicGetItem()));
			}
		}
		return qItems;
	}

	/**
	 * Returns a list of all query items in a query subject
	 * @param {QuerySubject} qs
	 * @return {Array}  List<QueryItem>
	 */
	static getQueryItems$1(qs) {
		return PropertySetter._getQueryItems$0(qs.basicGetItem());
	}

	/**
	 * to Query subject?
	 * @param {SplitType} s
	 * @return {boolean}
	 */
	static needToSplitToQueryItem(s) {
		var parts = s.ref.split(new RegExp("\\."));
		return parts.length > 1 || PropertySetter.isOnePartNameToQueryItem(s);
	}

	static isOnePartNameToQueryItem(s) {
		return s.columnTreatment;
	}

	static _setSpecialFlagForOnePartNameToQueryItem(s) {
		s.columnTreatment = SplitColumnTreatment.SHOW;
	}

	static _resetSpecialFlagForOnePartNameToQueryItem(s) {
		s.columnTreatment = null;
	}

	static getQueryItems(a0) {
		var args = arguments;
		if (args.length == 1 && (a0 == null || Object.prototype.toString.call(a0) === "[object Array]")) {
			return PropertySetter.getQueryItems$0(a0);
		}
		return PropertySetter.getQueryItems$1(a0);
	}
}


// WEBPACK FOOTER //
// ./src/generated/PropertySetter.js